<template>
  <BaseTemplate v-if="!isKioskMode" app-name="" page-title="">
    <template #content>
      <div
        class="min-h-screen bg-gradient-to-br from-slate-50 to-slate-100 dark:from-slate-900 dark:to-slate-800 p-4 transition-all duration-300">
        <div class="mb-6">
          <div
            class="flex flex-col items-center justify-center w-full max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 space-y-4 sm:space-y-0 sm:flex-row sm:gap-4 mb-5">
            <div v-if="!isKioskMode && (currentView === 'overview' || currentView === 'detailed')"
              class="relative w-full sm:w-96">
              <search-icon class="absolute left-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-gray-400" />
              <input type="text" placeholder="Buscar servidores..."
                class="w-full pl-10 pr-4 py-2.5 rounded-lg border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800 text-gray-900 dark:text-gray-200 focus:outline-none focus:ring-2 focus:ring-blue-500 transition-all"
                v-model="searchQuery" @input="handleSearchInput" />
            </div>
          </div>

          <div class="flex flex-col sm:flex-row items-start sm:items-center gap-4 mb-6">
            <div v-if="!isKioskMode && (currentView === 'overview' || currentView === 'detailed')"
              class="flex flex-wrap gap-2">
              <button @click="setActiveFilter('all')" :class="[
                'px-3 py-1.5 rounded-lg text-sm font-medium transition-all',
                activeFilter === 'all'
                  ? 'bg-blue-600 text-white shadow-md shadow-blue-200 dark:shadow-blue-900/30'
                  : 'bg-white dark:bg-gray-800 text-gray-700 dark:text-gray-300 border border-gray-200 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-700'
              ]">
                Todos ({{ servers.length }})
              </button>
              <button @click="setActiveFilter('online')" :class="[
                'px-3 py-1.5 rounded-lg text-sm font-medium transition-all',
                activeFilter === 'online'
                  ? 'bg-green-600 text-white shadow-md shadow-green-200 dark:shadow-green-900/30'
                  : 'bg-white dark:bg-gray-800 text-gray-700 dark:text-gray-300 border border-gray-200 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-700'
              ]">
                <span class="flex items-center gap-1">
                  <check-circle-icon class="h-3.5 w-3.5" />
                  Online ({{ onlineServers }})
                </span>
              </button>
              <button @click="setActiveFilter('warning')" :class="[
                'px-3 py-1.5 rounded-lg text-sm font-medium transition-all',
                activeFilter === 'warning'
                  ? 'bg-yellow-600 text-white shadow-md shadow-yellow-200 dark:shadow-yellow-900/30'
                  : 'bg-white dark:bg-gray-800 text-gray-700 dark:text-gray-300 border border-gray-200 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-700'
              ]">
                <span class="flex items-center gap-1">
                  <alert-triangle-icon class="h-3.5 w-3.5" />
                  Alerta ({{ warningServers }})
                </span>
              </button>
              <button @click="setActiveFilter('offline')" :class="[
                'px-3 py-1.5 rounded-lg text-sm font-medium transition-all',
                activeFilter === 'offline'
                  ? 'bg-red-600 text-white shadow-md shadow-red-200 dark:shadow-red-900/30'
                  : 'bg-white dark:bg-gray-800 text-gray-700 dark:text-gray-300 border border-gray-200 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-700'
              ]">
                <span class="flex items-center gap-1">
                  <x-circle-icon class="h-3.5 w-3.5" />
                  Offline ({{ offlineServers }})
                </span>
              </button>
            </div>

            <!-- Filtros de Tipo de Servidor -->
            <div v-if="!isKioskMode && (currentView === 'overview' || currentView === 'detailed')"
              class="flex flex-wrap gap-2">
              <span class="text-xs font-medium text-gray-500 dark:text-gray-400 self-center mr-2"></span>
              <button @click="setActiveTypeFilter('all')" :class="[
                'px-3 py-1.5 rounded-lg text-sm font-medium transition-all',
                activeTypeFilter === 'all'
                  ? 'bg-purple-600 text-white shadow-md shadow-purple-200 dark:shadow-purple-900/30'
                  : 'bg-white dark:bg-gray-800 text-gray-700 dark:text-gray-300 border border-gray-200 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-700'
              ]">
                Todos os Tipos
              </button>
              <button @click="setActiveTypeFilter('Servidor - Avançada')" :class="[
                'px-3 py-1.5 rounded-lg text-sm font-medium transition-all',
                activeTypeFilter === 'Servidor - Avançada'
                  ? 'bg-indigo-600 text-white shadow-md shadow-indigo-200 dark:shadow-indigo-900/30'
                  : 'bg-white dark:bg-gray-800 text-gray-700 dark:text-gray-300 border border-gray-200 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-700'
              ]">
                <span class="flex items-center gap-1">
                  <cpu-icon class="h-3.5 w-3.5" />
                  Avançadas
                </span>
              </button>
   

            </div>

            <!-- Filtros de Hosts Específicos -->
            <div v-if="!isKioskMode && (currentView === 'overview' || currentView === 'detailed') && hosts.length > 0"
              class="flex flex-wrap gap-2">
              <span class="text-xs font-medium text-gray-500 dark:text-gray-400 self-center mr-2">Hosts:</span>
              <button @click="setActiveHostFilter('all')" :class="[
                'px-3 py-1.5 rounded-lg text-sm font-medium transition-all',
                activeHostFilter === 'all'
                  ? 'bg-teal-600 text-white shadow-md shadow-teal-200 dark:shadow-teal-900/30'
                  : 'bg-white dark:bg-gray-800 text-gray-700 dark:text-gray-300 border border-gray-200 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-700'
              ]">
                Todos os Hosts
              </button>
              <button 
                v-for="host in hosts" 
                :key="host.id"
                @click="setActiveHostFilter(host.id.toString())" 
                :class="[
                  'px-3 py-1.5 rounded-lg text-sm font-medium transition-all',
                  activeHostFilter === host.id.toString()
                    ? 'bg-cyan-600 text-white shadow-md shadow-cyan-200 dark:shadow-cyan-900/30'
                    : 'bg-white dark:bg-gray-800 text-gray-700 dark:text-gray-300 border border-gray-200 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-700'
                ]">
                <span class="flex items-center gap-1">
                  <server-icon class="h-3.5 w-3.5" />
                  {{ host.nome }}
                </span>
              </button>
            </div>

            <div class="hidden sm:flex gap-3 sm:ml-auto">
              <button @click="setView('overview')" :class="[
                'px-4 py-2 rounded-lg border font-medium transition-all flex items-center gap-2',
                currentView === 'overview'
                  ? 'bg-blue-600 text-white border-blue-600 dark:border-blue-500'
                  : 'bg-white dark:bg-gray-800 text-gray-700 dark:text-gray-300 border-gray-200 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-700'
              ]">
                <grid-icon class="h-4 w-4" />
                Cards
              </button>
              <button @click="setView('detailed')" :class="[
                'px-4 py-2 rounded-lg border font-medium transition-all flex items-center gap-2',
                currentView === 'detailed'
                  ? 'bg-blue-600 text-white border-blue-600 dark:border-blue-500'
                  : 'bg-white dark:bg-gray-800 text-gray-700 dark:text-gray-300 border-gray-200 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-700'
              ]">
                <list-icon class="h-4 w-4" />
                Detalhado
              </button>
             <!-- <button @click="setView('general')" :class="[
                'px-4 py-2 rounded-lg border font-medium transition-all flex items-center gap-2',
                currentView === 'general'
                  ? 'bg-blue-600 text-white border-blue-600 dark:border-blue-500'
                  : 'bg-white dark:bg-gray-800 text-gray-700 dark:text-gray-300 border-gray-200 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-700'
              ]">
                <bar-icon class="h-4 w-4" />
                Visão Geral
              </button> -->
              <button @click="toggleKioskMode" :class="[
                'px-4 py-2 rounded-lg border font-medium transition-all flex items-center gap-2',
                isKioskMode
                  ? 'bg-red-600 text-white border-red-600 dark:border-red-500'
                  : 'bg-white dark:bg-gray-800 text-gray-700 dark:text-gray-300 border-gray-200 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-700'
              ]">
                <maximize-2-icon v-if="!isKioskMode" class="h-4 w-4" />
                <minimize-2-icon v-else class="h-4 w-4" />
                {{ isKioskMode ? '' : '' }}
              </button>
            </div>
          </div>
        </div>

        <div v-if="currentView === 'overview' || currentView === 'detailed'"
          class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 mb-6">
          <div
            class="bg-white dark:bg-gray-800 rounded-xl  shadow-sm hover:shadow-md border border-gray-100 dark:border-gray-700 p-5 transition-all duration-200">
            <div class="flex items-center justify-between">
              <div>
                <p class="text-sm font-medium text-gray-500 dark:text-gray-400">Total de Servidores</p>
                <div class="flex items-baseline mt-1">
                  <p class="text-2xl font-bold text-gray-900 dark:text-white">{{ filteredTotalServers }}</p>
                </div>
              </div>
              <div class="h-14 w-14 bg-blue-100 dark:bg-blue-900/30 rounded-full flex items-center justify-center">
                <ServerIcon class="h-7 w-7 text-blue-600 dark:text-blue-400" />
              </div>
            </div>
          </div>

          <div
            class="bg-white dark:bg-gray-800 rounded-xl shadow-sm hover:shadow-md border border-gray-100 dark:border-gray-700 p-5 transition-all duration-200">
            <div class="flex items-center justify-between">
              <div>
                <p class="text-sm font-medium text-gray-500 dark:text-gray-400">Servidores Online</p>
                <div class="flex items-baseline mt-1">
                  <p class="text-2xl font-bold text-green-600 dark:text-green-400">{{ filteredOnlineServers }}</p>
                  <p class="ml-2 text-xs text-gray-500 dark:text-gray-400">de {{ filteredTotalServers }}</p>
                </div>
              </div>
              <div class="h-14 w-14 bg-green-100 dark:bg-green-900/30 rounded-full flex items-center justify-center">
                <check-circle-icon class="h-7 w-7 text-green-600 dark:text-green-400" />
              </div>
            </div>
            <div class="mt-3 text-xs text-gray-500 dark:text-gray-400">
              <span class="inline-flex items-center">
                <span class="inline-block h-2 w-2 rounded-full bg-green-500 mr-1"></span>
                {{ filteredTotalServers > 0 ? Math.round((filteredOnlineServers / filteredTotalServers) * 100) : 0 }}% de disponibilidade
              </span>
            </div>
          </div>

          <div
            class="bg-white dark:bg-gray-800 rounded-xl shadow-sm hover:shadow-md border border-gray-100 dark:border-gray-700 p-5 transition-all duration-200">
            <div class="flex items-center justify-between">
              <div>
                <p class="text-sm font-medium text-gray-500 dark:text-gray-400">Alertas Ativos</p>
                <div class="flex items-baseline mt-1">
                  <p class="text-2xl font-bold text-yellow-600 dark:text-yellow-400">{{ filteredActiveAlerts }}</p>
                </div>
              </div>
              <div
                class="h-14 w-14 bg-yellow-100 dark:bg-yellow-900/30 rounded-full flex items-center justify-center relative">
                <alert-triangle-icon class="h-7 w-7 text-yellow-600 dark:text-yellow-400 animate-pulse" />
                <span class="absolute h-3 w-3 rounded-full bg-yellow-400 opacity-70 animate-pulse"
                  style="top: 6px; right: 6px;"></span>
              </div>
            </div>
            <div class="mt-3 text-xs text-gray-500 dark:text-gray-400">
              <span class="inline-flex items-center">
                <span class="inline-block h-2 w-2 rounded-full bg-yellow-500 mr-1 animate-pulse"></span>
                {{ criticalAlerts }} alertas críticos
              </span>
            </div>
          </div>
        </div>

        <div v-if="currentView === 'overview'"
          class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          <div v-for="server in (isKioskMode ? currentPageServers : filteredServers)" :key="server?.id" :class="[
            'bg-white dark:bg-gray-800 rounded-xl shadow-sm hover:shadow-lg border border-gray-100 dark:border-gray-700 transition-all duration-200 cursor-pointer group min-h-[480px]',
            (getEffectiveStatus(server) === 'warning' || getStatusTextForCard(server) === 'Funcionamento Parcial') && getEffectiveStatus(server) !== 'offline' ? 'animate-alert-glow' : '',
            getEffectiveStatus(server) === 'offline' ? 'animate-offline-glow' : ''
          ]" @click="selectServerForDetailedView(server)">
            <div class="p-5 border-b border-gray-100 dark:border-gray-700">
              <div class="flex items-center justify-between">
                <div class="flex items-center gap-3">
                  <div class="relative">
                    <div v-if="getEffectiveStatus(server) === 'offline'"
                      class="h-3.5 w-3.5 rounded-full bg-red-500 flex items-center justify-center">
                      <XCircleIcon class="h-full w-full text-white p-0.5" />
                    </div>
                    <div v-else-if="getEffectiveStatus(server) === 'warning'"
                      class="h-3.5 w-3.5 rounded-full bg-yellow-500 flex items-center justify-center">
                      <AlertTriangleIcon class="h-2.5 w-2.5 text-white" />
                    </div>
                    <div v-else-if="getEffectiveStatus(server) === 'online'"
                      class="h-3.5 w-3.5 rounded-full bg-green-500 flex items-center justify-center">
                      <CheckCircleIcon class="h-full w-full text-white p-0.5" />
                    </div>
                    <div v-else class="h-3.5 w-3.5 rounded-full bg-gray-500 flex items-center justify-center">
                    </div>

                    <div v-if="getEffectiveStatus(server) === 'online'"
                      class="absolute inset-0 h-3.5 w-3.5 rounded-full animate-ping opacity-75 bg-green-400"></div>
                    <div v-if="getEffectiveStatus(server) === 'warning'"
                      class="absolute inset-0 h-3.5 w-3.5 rounded-full animate-ping opacity-75 bg-yellow-400"></div>
                  </div>
                  <div>
                    <div class="flex items-center gap-1">
                      <div class="flex items-center gap-2">
                        <h3
                          :class="['font-semibold group-hover:text-blue-600 dark:group-hover:text-blue-400 transition-colors', isKioskMode ? 'text-2xl' : 'text-base']">
                          <span
                            :class="['truncate', getEffectiveStatus(server) === 'offline' ? 'text-gray-400 dark:text-gray-500' : 'text-gray-900 dark:text-white', isKioskMode ? 'max-w-[200px]' : 'max-w-[120px] sm:max-w-[150px]']">
                            {{ server.display_name || server.unidade_nome || server.hostname }}
                          </span>
                        </h3>
                        <button v-if="!isKioskMode"
                          @click="openEditModal(server)"
                          class="p-1 text-gray-400 hover:text-gray-600 dark:hover:text-gray-300 transition-colors"
                          title="Editar nome de exibição">
                          <Edit2 class="h-3 w-3" />
                        </button>
                      </div>
                      <!-- Ícones de status do link -->
                      <template v-if="server.link?.primaryIP && server.link?.primaryIP !== 'N/A'">
                        <Globe
                          :class="['h-4 w-4', getEffectiveStatus(server) === 'offline' ? 'opacity-60 grayscale' : getLinkGlobeColor(server.link, 'primary')]" />
                        <template v-if="server.link.sync_primario === 'on'">
                          <RefreshCw
                            :class="['h-3.5 w-3.5', getEffectiveStatus(server) === 'offline' ? 'opacity-60 grayscale' : 'text-blue-500 animate-spin']" />
                        </template>
                        <template v-else-if="server.link.sync_primario === 'off'">
                          <RefreshCwOff
                            :class="['h-3.5 w-3.5', getEffectiveStatus(server) === 'offline' ? 'opacity-60 grayscale' : 'text-red-500']" />
                        </template>
                      </template>
                      <template v-if="server.link?.secondaryIP && server.link?.secondaryIP !== 'N/A'">
                        <Globe
                          :class="['h-4 w-4 ml-1', getEffectiveStatus(server) === 'offline' ? 'opacity-60 grayscale' : getLinkGlobeColor(server.link, 'secondary')]" />
                        <template v-if="server.link.sync_secundario === 'on'">
                          <RefreshCw
                            :class="['h-3.5 w-3.5 ml-0.5', getEffectiveStatus(server) === 'offline' ? 'opacity-60 grayscale' : 'text-blue-500 animate-spin']" />
                        </template>
                        <template v-else-if="server.link.sync_secundario === 'off'">
                          <RefreshCwOff
                            :class="['h-3.5 w-3.5 ml-0.5', getEffectiveStatus(server) === 'offline' ? 'opacity-60 grayscale' : 'text-red-500']" />
                        </template>
                      </template>
                    </div>
                    <!-- Informações básicas do servidor -->
                    <div class="mt-2 space-y-1">
                      <div v-if="server.tipo_nome" class="flex items-center gap-1">
                        <span class="text-xs px-2 py-0.5 rounded-full bg-blue-100 dark:bg-blue-900/30 text-blue-700 dark:text-blue-400 font-medium">
                          {{ server.tipo_nome }}
                        </span>
                      </div>
                      <div v-if="server.modelo_nome || server.marca_nome" class="text-xs text-gray-600 dark:text-gray-400">
                        <span v-if="server.marca_nome">{{ server.marca_nome }}</span>
                        <span v-if="server.marca_nome && server.modelo_nome"> - </span>
                        <span v-if="server.modelo_nome">{{ server.modelo_nome }}</span>
                      </div>
                      <div v-if="server.serial_number" class="text-xs text-gray-500 dark:text-gray-500 font-mono">
                        S/N: {{ server.serial_number }}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="text-right">
                  <p
                    :class="['text-xs', getEffectiveStatus(server) === 'offline' ? 'text-gray-400 dark:text-gray-500' : 'text-gray-500 dark:text-gray-400', isKioskMode ? 'text-base' : '']">
                    Uptime</p>
                  <p
                    :class="['text-sm font-medium', getEffectiveStatus(server) === 'offline' ? 'text-gray-400 dark:text-gray-500' : 'text-gray-900 dark:text-gray-200', isKioskMode ? 'text-xl' : '']">
                    {{ getEffectiveStatus(server) === 'offline' ? 'N/A' : formatUptime(server.uptime) }}
                  </p>
                </div>
              </div>
            </div>

            <template v-if="getEffectiveStatus(server) !== 'offline'">
              <div class="p-5 space-y-4">
                <!-- Status do Link - DESTACADO -->
                <div class="bg-gray-50 dark:bg-gray-900/20 rounded-lg p-3 border border-gray-200 dark:border-gray-700">
                  <div class="flex items-center justify-between mb-2">
                    <div class="flex items-center gap-2">
                      <Globe class="h-4 w-4 text-blue-600 dark:text-blue-400" />
                      <span class="text-sm font-semibold text-gray-900 dark:text-white">Status do Link</span>
                    </div>
                    <span :class="getLinkStatusBadgeClass(server)" class="px-2 py-0.5 text-xs rounded-full font-medium">
                      {{ getStatusTextForCard(server) }}
                    </span>
                  </div>
                  
                  <div class="space-y-2">
                    <template v-if="server.link && (server.link.primaryIP || server.link.secondaryIP)">
                      <div v-if="server.link.primaryIP && server.link.primaryIP !== 'N/A' && server.link.primaryIP !== ''" 
                           class="flex items-center justify-between text-xs">
                        <div class="flex items-center gap-1">
                          <CheckCircleIcon v-if="server.link.sync_primario === 'on'" class="h-3 w-3 text-green-500" />
                          <RefreshCwOff v-else class="h-3 w-3 text-red-500" />
                          <span class="text-gray-700 dark:text-gray-300">Primário</span>
                        </div>
                        <span class="text-gray-600 dark:text-gray-400 font-mono">{{ server.link.primaryIP }}</span>
                      </div>
                      
                      <div v-if="server.link.secondaryIP && server.link.secondaryIP !== 'N/A' && server.link.secondaryIP !== ''" 
                           class="flex items-center justify-between text-xs">
                        <div class="flex items-center gap-1">
                          <CheckCircleIcon v-if="server.link.sync_secundario === 'on'" class="h-3 w-3 text-green-500" />
                          <RefreshCwOff v-else class="h-3 w-3 text-red-500" />
                          <span class="text-gray-700 dark:text-gray-300">Secundário</span>
                        </div>
                        <span class="text-gray-600 dark:text-gray-400 font-mono">{{ server.link.secondaryIP }}</span>
                      </div>
                    </template>
                    <div v-else class="text-center py-2 text-gray-500 dark:text-gray-400 text-xs">
                      <Globe class="h-4 w-4 mx-auto mb-1 opacity-50" />
                      <span>Sem link</span>
                    </div>
                  </div>
                </div>

                <!-- Métricas de Sistema -->
                <div class="flex flex-wrap justify-center gap-x-2 gap-y-4">
                  <div class="flex flex-col items-center" :class="isKioskMode ? 'w-36' : 'w-24'">
                    <div class="relative" :class="isKioskMode ? 'h-32 w-32' : 'h-20 w-20'">
                      <!-- Gráfico Chart.js para CPU -->
                      <div v-if="isKioskMode" class="h-32 w-32">
                        <Doughnut :data="getCpuChartData(server)" :options="getKioskChartOptions()" />
                        <div class="absolute inset-0 flex items-center justify-center">
                          <span class="text-2xl font-bold text-gray-900 dark:text-white">{{ server.cpu_percent }}%</span>
                        </div>
                      </div>
                      <!-- SVG original para modo normal -->
                      <div v-else>
                        <svg class="h-20 w-20" viewBox="0 0 36 36">
                          <path class="stroke-current text-gray-200 dark:text-gray-700 fill-none" stroke-width="3"
                            d="M18 2.0845 a 15.9155 15.9155 0 1 1 0 31.831 a 15.9155 15.9155 0 1 1 0 -31.831" />
                          <path :class="getGaugeColor(server.cpu_percent, getEffectiveStatus(server))" fill="none"
                            stroke-width="3" stroke-linecap="round" :d="describeArcGauge(18, 18, 15.9155, server.cpu_percent)" class="transition-all duration-500 ease-in-out [transition-property:d,stroke]" />
                        </svg>
                        <div class="absolute inset-0 flex items-center justify-center">
                          <span class="text-base font-bold text-gray-900 dark:text-white">{{ server.cpu_percent }}%</span>
                        </div>
                      </div>
                    </div>
                    <span :class="isKioskMode ? 'text-lg mt-4 text-gray-900 dark:text-white' : 'text-sm mt-2 text-gray-900 dark:text-white'">CPU</span>
                  </div>
                  
                  <div class="flex flex-col items-center" :class="isKioskMode ? 'w-36' : 'w-24'">
                    <div class="relative" :class="isKioskMode ? 'h-32 w-32' : 'h-20 w-20'">
                      <!-- Gráfico Chart.js para RAM -->
                      <div v-if="isKioskMode" class="h-32 w-32">
                        <Doughnut :data="getMemoryChartData(server)" :options="getKioskChartOptions()" />
                        <div class="absolute inset-0 flex items-center justify-center">
                          <span class="text-2xl font-bold text-gray-900 dark:text-white">{{ server.mem_percent }}%</span>
                        </div>
                      </div>
                      <!-- SVG original para modo normal -->
                      <div v-else>
                        <svg class="h-20 w-20" viewBox="0 0 36 36">
                          <path class="stroke-current text-gray-200 dark:text-gray-700 fill-none" stroke-width="3"
                            d="M18 2.0845 a 15.9155 15.9155 0 1 1 0 31.831 a 15.9155 15.9155 0 1 1 0 -31.831" />
                          <path :class="getGaugeColor(server.mem_percent, getEffectiveStatus(server))" fill="none"
                            stroke-width="3" stroke-linecap="round" :d="describeArcGauge(18, 18, 15.9155, server.mem_percent)" class="transition-all duration-500 ease-in-out [transition-property:d,stroke]" />
                        </svg>
                        <div class="absolute inset-0 flex items-center justify-center">
                          <span class="text-base font-bold text-gray-900 dark:text-white">{{ server.mem_percent }}%</span>
                        </div>
                      </div>
                    </div>
                    <span :class="isKioskMode ? 'text-lg mt-4 text-gray-900 dark:text-white' : 'text-sm mt-2 text-gray-900 dark:text-white'">RAM</span>
                  </div>
                  
                  <template v-if="server.disks && Object.keys(server.disks).length > 0">
                    <template v-for="(disk, mount) in server.disks" :key="mount">
                      <div class="flex flex-col items-center" :class="isKioskMode ? 'w-36' : 'w-24'">
                        <div class="relative" :class="isKioskMode ? 'h-32 w-32' : 'h-20 w-20'">
                          <!-- Gráfico Chart.js para Disco -->
                          <div v-if="isKioskMode" class="h-32 w-32">
                            <Doughnut :data="getDiskChartData(disk)" :options="getKioskChartOptions()" />
                            <div class="absolute inset-0 flex items-center justify-center">
                              <span class="text-2xl font-bold text-gray-900 dark:text-white">{{ disk.percent }}%</span>
                            </div>
                          </div>
                          <!-- SVG original para modo normal -->
                          <div v-else>
                            <svg class="h-20 w-20" viewBox="0 0 36 36">
                              <path class="stroke-current text-gray-200 dark:text-gray-700 fill-none" stroke-width="3"
                                d="M18 2.0845 a 15.9155 15.9155 0 1 1 0 31.831 a 15.9155 15.9155 0 1 1 0 -31.831" />
                              <path :class="getGaugeColor(disk.percent, getEffectiveStatus(server))" fill="none"
                                stroke-width="3" stroke-linecap="round" :d="describeArcGauge(18, 18, 15.9155, disk.percent)" class="transition-all duration-500 ease-in-out [transition-property:d,stroke]" />
                            </svg>
                            <div class="absolute inset-0 flex items-center justify-center">
                              <span class="text-base font-bold text-gray-900 dark:text-white">{{ disk.percent }}%</span>
                            </div>
                          </div>
                        </div>
                        <span :class="isKioskMode ? 'text-lg mt-4 text-center truncate w-full text-gray-900 dark:text-white' : 'text-sm mt-2 text-center truncate w-full text-gray-900 dark:text-white'">{{ mount }}</span>
                      </div>
                    </template>
                  </template>
                  <template v-else>
                    <div class="flex flex-col items-center" :class="isKioskMode ? 'w-36' : 'w-24'">
                      <div class="relative" :class="isKioskMode ? 'h-32 w-32' : 'h-20 w-20'">
                        <!-- Gráfico Chart.js para Disco vazio -->
                        <div v-if="isKioskMode" class="h-32 w-32">
                          <Doughnut :data="getEmptyDiskChartData()" :options="getKioskChartOptions()" />
                          <div class="absolute inset-0 flex items-center justify-center">
                            <span class="text-2xl font-bold text-gray-900 dark:text-white">0%</span>
                          </div>
                        </div>
                        <!-- SVG original para modo normal -->
                        <div v-else>
                          <svg class="h-20 w-20" viewBox="0 0 36 36">
                            <path class="stroke-current text-gray-200 dark:text-gray-700 fill-none" stroke-width="3"
                              d="M18 2.0845 a 15.9155 15.9155 0 1 1 0 31.831 a 15.9155 15.9155 0 1 1 0 -31.831" />
                            <path class="stroke-gray-400 dark:stroke-gray-500" fill="none" stroke-width="3"
                              stroke-linecap="round" :d="describeArcGauge(18, 18, 15.9155, 0)" />
                          </svg>
                          <div class="absolute inset-0 flex items-center justify-center">
                            <span class="text-sm font-bold text-gray-900 dark:text-white">0%</span>
                          </div>
                        </div>
                      </div>
                      <span :class="isKioskMode ? 'text-lg mt-4 text-gray-900 dark:text-white' : 'text-xs mt-1 text-gray-900 dark:text-white'">Disco</span>
                    </div>
                  </template>
                </div>

                <div class="flex items-center justify-between pt-3 border-t border-gray-100 dark:border-gray-700">
                  <div class="flex items-center gap-4">
                    <div class="flex items-center gap-1">
                      <arrow-down-icon class="h-3 w-3 text-green-500 dark:text-green-400" />
                      <span class="text-sm text-gray-600 dark:text-gray-300">{{ formatNetworkSpeed(server.net_down)
                        }}</span>
                    </div>
                    <div class="flex items-center gap-1">
                      <arrow-up-icon class="h-3 w-3 text-blue-500 dark:text-blue-400" />
                      <span class="text-sm text-gray-600 dark:text-gray-300">{{ formatNetworkSpeed(server.net_up)
                        }}</span>
                    </div>
                  </div>
                  <div class="flex items-center gap-2">
                    <div>
                      <span :class="[
                        'px-2 py-0.5 text-xs rounded-full',
                        countStoppedServices(server.services) > 0
                          ? 'bg-red-100 dark:bg-red-900/30 text-red-700 dark:text-red-400 font-semibold'
                          : 'bg-gray-100 dark:bg-gray-700 text-gray-600 dark:text-gray-300'
                      ]">
                        {{ countStoppedServices(server.services) }} serv. parado(s)
                      </span>
                    </div>
                    <span v-if="hasWarnings(server) && getEffectiveStatus(server) !== 'offline'"
                      class="px-2 py-0.5 text-xs rounded-full bg-yellow-100 dark:bg-yellow-900/30 text-yellow-700 dark:text-yellow-400">
                      Alerta
                    </span>
                  </div>
                </div>
              </div>
            </template>
            <template v-else>
              <div class="relative flex min-h-[140px] items-center justify-center p-5">
                <span class="z-[1] px-3 py-1 text-base font-semibold text-gray-400 dark:text-gray-500">OFFLINE</span>
              </div>
            </template>
          </div>
        </div>

        <!-- Resto do código permanece igual... -->
        <div v-if="currentView === 'detailed'" class="space-y-6">
          <div v-for="serverItem in detailedViewLoopServers" :key="serverItem.id"
            class="bg-white dark:bg-gray-800 rounded-xl shadow-sm hover:shadow-md border border-gray-100 dark:border-gray-700 transition-all duration-200">
            <div class="p-6 border-b border-gray-100 dark:border-gray-700">
              <div class="flex flex-col md:flex-row md:items-center justify-between gap-4">
                <div class="flex items-center gap-4">
                  <div class="relative h-10 w-10 flex items-center justify-center rounded-full" :class="{
                    'bg-green-100 dark:bg-green-900/30': getStatusTextForCard(serverItem) === 'Pleno Funcionamento',
                    'bg-yellow-100 dark:bg-yellow-900/30': getStatusTextForCard(serverItem) === 'Funcionamento Parcial',
                    'bg-red-100 dark:bg-red-900/30': getStatusTextForCard(serverItem) === 'Fora de Operação',
                    'bg-gray-100 dark:bg-gray-700': getStatusTextForCard(serverItem) === 'Desconhecido'
                  }">
                    <CheckCircleIcon v-if="getStatusTextForCard(serverItem) === 'Pleno Funcionamento'"
                      class="h-5 w-5 text-green-600 dark:text-green-400" />
                    <AlertTriangleIcon v-else-if="getStatusTextForCard(serverItem) === 'Funcionamento Parcial'"
                      class="h-5 w-5 text-yellow-600 dark:text-yellow-400" />
                    <XCircleIcon v-else-if="getStatusTextForCard(serverItem) === 'Fora de Operação'"
                      class="h-5 w-5 text-red-600 dark:text-red-400" />
                    <div
                      v-if="getEffectiveStatus(serverItem) === 'online' && getStatusTextForCard(serverItem) === 'Pleno Funcionamento'"
                      class="absolute inset-0 h-full w-full rounded-full animate-ping opacity-75" :class="{
                        'bg-green-400': getStatusTextForCard(serverItem) === 'Pleno Funcionamento',
                        'bg-yellow-400': getStatusTextForCard(serverItem) === 'Funcionamento Parcial',
                      }"></div>
                  </div>

                  <div>
                    <div class="flex items-center gap-2">
                      <h2 class="text-xl font-bold text-gray-900 dark:text-white">{{ serverItem.unidade_nome ||
                        serverItem.hostname }}</h2>
                      <span class="px-2 py-0.5 text-xs rounded-full" :class="{
                        'bg-green-100 dark:bg-green-900/30 text-green-700 dark:text-green-400': getStatusTextForCard(serverItem) === 'Pleno Funcionamento',
                        'bg-yellow-100 dark:bg-yellow-900/30 text-yellow-700 dark:text-yellow-400': getStatusTextForCard(serverItem) === 'Funcionamento Parcial',
                        'bg-red-100 dark:bg-red-900/30 text-red-700 dark:text-red-400': getStatusTextForCard(serverItem) === 'Fora de Operação'
                      }">
                        {{ getStatusTextForCard(serverItem) }}
                      </span>
                    </div>
                    <!-- Informações básicas do servidor na visualização detalhada -->
                    <div class="mt-2 space-y-1">
                      <div v-if="serverItem.tipo_nome" class="flex items-center gap-1">
                        <span class="text-xs px-2 py-0.5 rounded-full bg-blue-100 dark:bg-blue-900/30 text-blue-700 dark:text-blue-400 font-medium">
                          {{ serverItem.tipo_nome }}
                        </span>
                      </div>
                      <div v-if="serverItem.modelo_nome || serverItem.marca_nome" class="text-sm text-gray-600 dark:text-gray-400">
                        <span v-if="serverItem.marca_nome">{{ serverItem.marca_nome }}</span>
                        <span v-if="serverItem.marca_nome && serverItem.modelo_nome"> - </span>
                        <span v-if="serverItem.modelo_nome">{{ serverItem.modelo_nome }}</span>
                      </div>
                      <div v-if="serverItem.serial_number" class="text-sm text-gray-500 dark:text-gray-500 font-mono">
                        S/N: {{ serverItem.serial_number }}
                      </div>
                      <p v-if="serverItem.cpu_model" class="text-gray-600 dark:text-gray-400 text-sm">{{ serverItem.cpu_model }}</p>
                    </div>
                  </div>
                </div>
                <div class="flex items-center gap-4">
                  <div class="text-right">
                    <p class="text-sm text-gray-500 dark:text-gray-400">Uptime</p>
                    <p class="font-medium text-gray-900 dark:text-white">{{ formatUptime(serverItem.uptime) }}</p>
                  </div>
                  <div class="text-right">
                    <p class="text-sm text-gray-500 dark:text-gray-400">IP</p>
                    <p class="font-medium text-gray-900 dark:text-white">
                      {{ getActiveIP(serverItem) }}
                    </p>
                  </div>

                  <div class="flex gap-2">
                    <button @click="openServerLink(serverItem)"
                      class="p-2 rounded-lg bg-blue-50 dark:bg-blue-900/20 text-blue-600 dark:text-blue-400 hover:bg-blue-100 dark:hover:bg-blue-900/40 transition-colors">
                      <external-link-icon class="h-4 w-4" />
                    </button>
                    <button
                      class="p-2 rounded-lg bg-gray-50 dark:bg-gray-700 text-gray-600 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-gray-600 transition-colors">
                      <more-horizontal-icon class="h-4 w-4" />
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <div class="p-6">
              <div class="grid grid-cols-1 md:grid-cols-3 gap-6">
                <div class="bg-gray-50 dark:bg-gray-900/20 rounded-xl p-5 space-y-4">
                  <div class="flex items-center justify-between">
                    <div class="flex items-center gap-2">
                      <cpu-icon class="h-5 w-5 text-gray-600 dark:text-gray-400" />
                      <h3 class="font-semibold text-gray-900 dark:text-white">CPU</h3>
                    </div>
                    <span :class="getUsageBadgeClass(serverItem.cpu_percent)" class="px-2 py-0.5 text-xs rounded-full">
                      {{ serverItem.cpu_percent }}%
                    </span>
                  </div>

                  <div class="relative h-20 w-20 mx-auto">
                    <svg class="h-20 w-20" viewBox="0 0 36 36">
                      <path class="stroke-current text-gray-200 dark:text-gray-700" fill="none" stroke-width="3"
                        d="M18 2.0845 a 15.9155 15.9155 0 1 1 0 31.831 a 15.9155 15.9155 0 1 1 0 -31.831" />
                      <path :class="getGaugeColor(serverItem.cpu_percent)" fill="none" stroke-width="3"
                        stroke-linecap="round" :d="describeArcGauge(18, 18, 15.9155, serverItem.cpu_percent)"
                        class="transition-all duration-1000 ease-out [transition-property:d,stroke]" />
                    </svg>
                    <div class="absolute inset-0 flex items-center justify-center">
                      <span class="text-lg font-bold text-gray-900 dark:text-white">{{ serverItem.cpu_percent }}%</span>
                    </div>
                  </div>

                  <div class="space-y-2">
                    <div class="flex justify-between text-sm">
                      <span class="text-gray-600 dark:text-gray-400">Núcleos</span>
                      <span class="font-medium text-gray-900 dark:text-white">{{ serverItem.cpu_cores || 'N/A' }}</span>
                    </div>
                    <div class="flex justify-between text-sm">
                      <span class="text-gray-600 dark:text-gray-400">Temperatura</span>
                      <span :class="{ 'text-red-600 dark:text-red-400': (serverItem.cpu_temp || 0) > 80 }"
                        class="font-medium text-gray-900 dark:text-white">
                        {{ serverItem.cpu_temp ? serverItem.cpu_temp + '°C' : 'N/A' }}
                      </span>
                    </div>
                    <div class="flex justify-between text-sm">
                      <span class="text-gray-600 dark:text-gray-400">Carga</span>
                      <span class="font-medium text-gray-900 dark:text-white">{{ serverItem.cpu_load || 'N/A' }}</span>
                    </div>
                  </div>
                </div>
                <div class="bg-gray-50 dark:bg-gray-900/20 rounded-xl p-5 space-y-4">
                  <div class="flex items-center justify-between">
                    <div class="flex items-center gap-2">
                      <hard-drive-icon class="h-5 w-5 text-gray-600 dark:text-gray-400" />
                      <h3 class="font-semibold text-gray-900 dark:text-white">Memória</h3>
                    </div>
                    <span :class="getUsageBadgeClass(serverItem.mem_percent)" class="px-2 py-0.5 text-xs rounded-full">
                      {{ serverItem.mem_percent }}%
                    </span>
                  </div>

                  <div class="relative h-20 w-20 mx-auto">
                    <svg class="h-20 w-20" viewBox="0 0 36 36">
                      <path class="stroke-current text-gray-200 dark:text-gray-700" fill="none" stroke-width="3"
                        d="M18 2.0845 a 15.9155 15.9155 0 1 1 0 31.831 a 15.9155 15.9155 0 1 1 0 -31.831" />
                      <path :class="getGaugeColor(serverItem.mem_percent)" fill="none" stroke-width="3"
                        stroke-linecap="round" :d="describeArcGauge(18, 18, 15.9155, serverItem.mem_percent)"
                        class="transition-all duration-500 ease-in-out [transition-property:d,stroke]" />
                    </svg>
                    <div class="absolute inset-0 flex items-center justify-center">
                      <span class="text-lg font-bold text-gray-900 dark:text-white">{{ serverItem.mem_percent }}%</span>
                    </div>
                  </div>

                  <div class="space-y-2">
                    <div class="flex justify-between text-sm">
                      <span class="text-gray-600 dark:text-gray-400">Total</span>
                      <span class="font-medium text-gray-900 dark:text-white">{{ formatBytes(serverItem.mem_total * 1024
                        * 1024)
                        }}</span>
                    </div>
                    <div class="flex justify-between text-sm">
                      <span class="text-gray-600 dark:text-gray-400">Usado</span>
                      <span class="font-medium text-gray-900 dark:text-white">{{ formatBytes(serverItem.mem_total *
                        (serverItem.mem_percent / 100) * 1024 * 1024) }}</span>
                    </div>
                    <div class="flex justify-between text-sm">
                      <span class="text-gray-600 dark:text-gray-400">Livre</span>
                      <span class="font-medium text-gray-900 dark:text-white">{{ formatBytes(serverItem.mem_total * (1 -
                        serverItem.mem_percent / 100) * 1024 * 1024) }}</span>
                    </div>
                  </div>
                </div>
                <template v-for="(disk, mount) in serverItem.disks" :key="mount">
                  <div class="bg-gray-50 dark:bg-gray-900/20 rounded-xl p-5 space-y-4">
                    <div class="flex items-center justify-between">
                      <div class="flex items-center gap-2">
                        <database-icon class="h-5 w-5 text-gray-600 dark:text-gray-400" />
                        <h3 class="font-semibold text-gray-900 dark:text-white">Disco {{ mount }}</h3>
                      </div>
                      <span :class="getUsageBadgeClass(disk.percent)" class="px-2 py-0.5 text-xs rounded-full">
                        {{ disk.percent }}%
                      </span>
                    </div>
                    <div class="relative h-20 w-20 mx-auto">
                      <svg class="h-20 w-20" viewBox="0 0 36 36">
                        <path class="stroke-current text-gray-200 dark:text-gray-700 fill-none" stroke-width="3"
                          d="M18 2.0845 a 15.9155 15.9155 0 1 1 0 31.831 a 15.9155 15.9155 0 1 1 0 -31.831" />
                        <path :class="getGaugeColor(disk.percent, getEffectiveStatus(serverItem))" fill="none"
                          stroke-width="3" stroke-linecap="round" :d="describeArcGauge(18, 18, 15.9155, disk.percent)" class="transition-all duration-500 ease-in-out [transition-property:d,stroke]" />
                      </svg>
                      <div class="absolute inset-0 flex items-center justify-center">
                        <span class="text-lg font-bold text-gray-900 dark:text-white">{{ disk.percent }}%</span>
                      </div>
                    </div>
                    <div class="space-y-2">
                      <div class="flex justify-between text-sm">
                        <span class="text-gray-600 dark:text-gray-400">Total</span>
                        <span class="font-medium text-gray-900 dark:text-white">{{ formatBytes(disk.total_gb * 1024 *
                          1024 * 1024) }}</span>
                      </div>
                      <div class="flex justify-between text-sm">
                        <span class="text-gray-600 dark:text-gray-400">Usado</span>
                        <span class="font-medium text-gray-900 dark:text-white">{{ formatBytes(disk.used_gb * 1024 *
                          1024 * 1024) }}</span>
                      </div>
                      <div class="flex justify-between text-sm">
                        <span class="text-gray-600 dark:text-gray-400">Livre</span>
                        <span class="font-medium text-gray-900 dark:text-white">{{ formatBytes((disk.total_gb -
                          disk.used_gb) * 1024 * 1024 * 1024) }}</span>
                      </div>
                    </div>
                  </div>
                </template>
              </div>
              <div class="mt-6">
                <UnidadeLinkCard :unidade="serverItem" :status="serverItem.link" />
              </div>
              <div class="mt-6 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
                <div class="bg-white dark:bg-gray-800 rounded-lg border border-gray-100 dark:border-gray-700 p-4">
                  <div class="flex items-center gap-2 mb-3">
                    <wifi-icon class="h-4 w-4 text-blue-600 dark:text-blue-400" />
                    <span class="text-sm font-medium text-gray-900 dark:text-white">Rede</span>
                  </div>
                  <div class="space-y-2">
                    <div class="flex justify-between text-sm">
                      <span class="text-gray-600 dark:text-gray-400">Download</span>
                      <span class="font-medium text-gray-900 dark:text-white">{{ formatNetworkSpeed(serverItem.net_down)
                        }}</span>
                    </div>
                    <div class="flex justify-between text-sm">
                      <span class="text-gray-600 dark:text-gray-400">Upload</span>
                      <span class="font-medium text-gray-900 dark:text-white">{{ formatNetworkSpeed(serverItem.net_up)
                        }}</span>
                    </div>
                    <div class="flex justify-between text-sm">
                      <span class="text-gray-600 dark:text-gray-400">Latência</span>
                      <span class="font-medium text-gray-900 dark:text-white">{{ serverItem.latency ? serverItem.latency
                        + 'ms'
                        : 'N/A' }}</span>
                    </div>
                  </div>
                </div>

                <div class="bg-white dark:bg-gray-800 rounded-lg border border-gray-100 dark:border-gray-700 p-4">
                  <div class="flex items-center gap-2 mb-3">
                    <calendar-icon class="h-4 w-4 text-purple-600 dark:text-purple-400" />
                    <span class="text-sm font-medium text-gray-900 dark:text-white">Backup</span>
                  </div>
                  <div class="space-y-2">
                    <div class="flex justify-between text-sm">
                      <span class="text-gray-600 dark:text-gray-400">Último backup</span>
                      <span class="font-medium text-gray-900 dark:text-white">{{ serverItem.last_backup }}</span>
                    </div>
                    <div class="flex justify-between text-sm">
                      <span class="text-gray-600 dark:text-gray-400">Status</span>
                      <span class="font-medium text-green-600 dark:text-green-400">Completo</span>
                    </div>
                    <div class="flex justify-between text-sm">
                      <span class="text-gray-600 dark:text-gray-400">Próximo</span>
                      <span class="font-medium text-gray-900 dark:text-white">N/A</span>
                    </div>
                  </div>
                </div>

                <div class="bg-white dark:bg-gray-800 rounded-lg border border-gray-100 dark:border-gray-700 p-4">
                  <div class="flex items-center gap-2 mb-3">
                    <settings-icon class="h-4 w-4 text-gray-600 dark:text-gray-400" />
                    <span class="text-sm font-medium text-gray-900 dark:text-white">Serviços</span>
                  </div>
                  <div class="space-y-2">
                    <div v-for="(service, name) in serverItem.services" :key="name"
                      class="flex justify-between text-sm">
                      <span class="text-gray-600 dark:text-gray-400 truncate" :title="name">{{ name }}</span>
                      <span :class="{
                        'text-green-600 dark:text-green-400': service.status === 'running',
                        'text-red-600 dark:text-red-400 font-semibold': service.status === 'stopped',
                        'text-gray-500 dark:text-gray-400': service.status !== 'running' && service.status !== 'stopped'
                      }" class="font-medium">
                        {{ service.status }}
                      </span>
                    </div>
                    <div v-if="Object.keys(serverItem.services || {}).length > 3" class="pt-1">
                      <button
                        class="w-full text-center text-xs text-blue-600 dark:text-blue-400 hover:text-blue-800 dark:hover:text-blue-300 transition-colors"
                        @click="openServicesModal(serverItem.services, serverItem.display_name || serverItem.unidade_nome || serverItem.hostname)">
                        Ver todos...
                      </button>
                    </div>
                  </div>
                </div>

                <div class="bg-white dark:bg-gray-800 rounded-lg border border-gray-100 dark:border-gray-700 p-4">
                  <div class="flex items-center gap-2 mb-3">
                    <key-icon class="h-4 w-4 text-amber-600 dark:text-amber-400" />
                    <span class="text-sm font-medium text-gray-900 dark:text-white">Segurança</span>
                  </div>
                  <div class="space-y-2">
                    <div class="flex justify-between text-sm">
                      <span class="text-gray-600 dark:text-gray-400">Token</span>
                      <span class="font-mono text-xs text-gray-900 dark:text-white">{{ serverItem.token }}</span>
                    </div>
                    <div class="flex justify-between text-sm">
                      <span class="text-gray-600 dark:text-gray-400">Firewall</span>
                      <span class="font-medium text-green-600 dark:text-green-400">Ativo</span>
                    </div>
                    <div class="flex justify-between text-sm">
                      <span class="text-gray-600 dark:text-gray-400">Atualizações</span>
                      <span class="font-medium text-gray-900 dark:text-white">{{ (serverItem.pending_updates &&
                        serverItem.pending_updates !== 'N/A' && serverItem.pending_updates !== '0') ?
                        `${serverItem.pending_updates} Pendentes` : 'Em dia' }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
  </BaseTemplate>

  <!-- MODO KIOSK MELHORADO -->
  <div v-else
    class="min-h-screen bg-gradient-to-br from-slate-900 via-blue-900 to-slate-900 text-white transition-all duration-300">
    
    <!-- Header do Kiosk -->
    <div class="bg-black/30 backdrop-blur-sm border-b border-white/10 p-6">
      <div class="flex items-center justify-between">
        <div class="flex items-center gap-4 min-w-[180px]">
          <img src="@/assets/logo_ccdti.png" alt="Logo CCDTI" class="h-12 w-auto" />
        </div>
        <div class="flex-1 flex flex-col items-center">
          <h1 class="text-4xl font-bold bg-gradient-to-r from-blue-400 to-cyan-300 bg-clip-text text-transparent text-center w-full">
            {{ kioskTitle }}
          </h1>
          <div class="flex gap-4 mt-4">
            <div class="bg-green-500/20 border border-green-400/30 rounded-lg px-4 py-2">
              <span class="text-green-300 text-lg font-semibold">{{ onlineServers }} Online</span>
            </div>
            <div class="bg-yellow-500/20 border border-yellow-400/30 rounded-lg px-4 py-2">
              <span class="text-yellow-300 text-lg font-semibold">{{ warningServers }} Alertas</span>
            </div>
            <div class="bg-red-500/20 border border-red-400/30 rounded-lg px-4 py-2">
              <span class="text-red-300 text-lg font-semibold">{{ offlineServers }} Offline</span>
            </div>
          </div>
        </div>
        <div class="text-right min-w-[120px]">
          <div class="text-2xl font-mono">{{ currentTime }}</div>
          <div class="text-sm text-gray-300">{{ currentDate }}</div>
        </div>
      </div>
    </div>

    <!-- Conteúdo do Kiosk -->
    <div class="p-8">
      <!-- Visão geral com gráficos Chart.js -->
      <div v-if="kioskDisplayState === 'overviewCharts'" class="grid grid-cols-1 lg:grid-cols-3 gap-8 mb-8">
        <!-- Gráfico de status geral -->
        <div class="bg-black/30 backdrop-blur-sm border border-white/10 rounded-2xl p-6">
          <h3 class="text-2xl font-bold mb-4 text-center">Status Geral</h3>
          <div class="h-64 relative">
            <Doughnut :data="filteredStatusChartData" :options="kioskChartOptions" />
          </div>
          <div class="mt-4 text-center">
            <div class="text-3xl font-bold">{{ filteredTotalServers }}</div>
            <div class="text-gray-300">Total de Servidores</div>
          </div>
        </div>

        <!-- Gráfico de CPU média -->
        <div class="bg-black/30 backdrop-blur-sm border border-white/10 rounded-2xl p-6">
          <h3 class="text-2xl font-bold mb-4 text-center">CPU Média</h3>
          <div class="h-64">
            <Line :data="cpuTrendData" :options="kioskLineChartOptions" />
          </div>
          <div class="mt-4 text-center">
            <div class="text-3xl font-bold">{{ averageCpu }}%</div>
            <div class="text-gray-300">Uso Médio</div>
          </div>
        </div>

        <!-- Gráfico de memória por servidor -->
        <div class="bg-black/30 backdrop-blur-sm border border-white/10 rounded-2xl p-6">
          <h3 class="text-2xl font-bold mb-4 text-center">Memória por Servidor</h3>
          <div class="h-64">
            <Bar :data="memoryChartData" :options="kioskBarChartOptions" />
          </div>
          <div class="mt-4 text-center">
            <div class="text-3xl font-bold">{{ averageMemory }}%</div>
            <div class="text-gray-300">Média Geral</div>
          </div>
        </div>
      </div> 

      <!-- Cards de servidores no modo kiosk -->
      <div v-if="kioskDisplayState === 'overviewCards'"
        class="grid grid-cols-3 gap-8">
        <div v-for="server in currentPageServers" :key="server.id" :class="[
          'bg-black/30 backdrop-blur-sm border rounded-2xl p-8 min-h-[520px] transition-all duration-300',
          getKioskServerBorderClass(server),
          (getEffectiveStatus(server) === 'warning' || getKioskStatusText(server) === 'Atenção Necessária') && getEffectiveStatus(server) !== 'offline' ? 'animate-alert-glow' : '',
          getEffectiveStatus(server) === 'offline' ? 'animate-offline-glow' : ''
        ]">
          <!-- Header do servidor -->
          <div class="flex justify-between items-start mb-6">
            <div class="flex items-center gap-3">
              <div :class="getKioskStatusIndicatorClass(server)" class="w-4 h-4 rounded-full animate-pulse"></div>
              <div>
                <div class="flex items-center gap-2">
                  <h3 class="text-2xl font-bold text-white">{{ server.display_name || server.unidade_nome || server.hostname }}</h3>
                  <template v-if="server.link && (server.link.primaryIP || server.link.secondaryIP)">
                    <RefreshCw v-if="server.link.primaryIP && server.link.sync_primario === 'on'" class="h-5 w-5 animate-spin text-blue-400" />
                    <RefreshCw v-if="server.link.secondaryIP && server.link.sync_secundario === 'on'" class="h-5 w-5 animate-spin text-blue-400" />
                  </template>
                </div>
                <!-- Informações básicas do servidor no modo kiosk -->
                <div class="mt-2 space-y-1">
                  <div v-if="server.tipo_nome" class="flex items-center gap-1">
                    <span class="text-sm px-2 py-1 rounded-full bg-blue-500/30 text-blue-300 font-medium border border-blue-400/30">
                      {{ server.tipo_nome }}
                    </span>
                  </div>
                  <div v-if="server.modelo_nome || server.marca_nome" class="text-sm text-gray-300">
                    <span v-if="server.marca_nome">{{ server.marca_nome }}</span>
                    <span v-if="server.marca_nome && server.modelo_nome"> - </span>
                    <span v-if="server.modelo_nome">{{ server.modelo_nome }}</span>
                  </div>
                  <div v-if="server.serial_number" class="text-sm text-gray-400 font-mono">
                    S/N: {{ server.serial_number }}
                  </div>
                </div>
              </div>
            </div>
            <div class="text-right">
              <div class="text-2xl font-bold text-white">{{ formatUptime(server.uptime) }}</div>
              <div class="text-sm text-gray-300">Uptime</div>
            </div>
          </div>

          <!-- Métricas com gráficos Chart.js -->
          <template v-if="getEffectiveStatus(server) !== 'offline'">
            <!-- Status do Link + Download/Upload -->
            <div class="mb-6 grid grid-cols-2 gap-4 items-stretch">
              <!-- Status do Link -->
              <div class="p-4 bg-white/10 rounded-xl border border-white/20 flex flex-col justify-between">
                <div class="flex items-center justify-between mb-3">
                  <div class="flex items-center gap-2">
                    <Globe class="h-5 w-5 text-blue-400" />
                    <span class="text-xl font-bold text-white">Status do Link</span>
                  </div>
                  <div :class="getKioskLinkStatusBadgeClass(server)" class="px-3 py-1 rounded-full text-lg font-bold"></div>
                </div>
                <div class="space-y-3">
                  <template v-if="server.link && (server.link.primaryIP || server.link.secondaryIP)">
                    <div v-if="server.link.primaryIP && server.link.primaryIP !== 'N/A' && server.link.primaryIP !== ''" 
                         class="flex items-center justify-between p-2 bg-white/5 rounded-lg">
                      <div class="flex items-center gap-2">
                        <CheckCircleIcon v-if="server.link.sync_primario === 'on'" class="h-5 w-5 text-green-400" />
                        <RefreshCwOff v-else class="h-5 w-5 text-red-400" />
                        <span class="text-white font-medium text-base">Link Primário</span>
                      </div>
                      <span class="text-gray-300 text-base">{{ server.link.primaryIP }}</span>
                    </div>
                    
                    <div v-if="server.link.secondaryIP && server.link.secondaryIP !== 'N/A' && server.link.secondaryIP !== ''" 
                         class="flex items-center justify-between p-2 bg-white/5 rounded-lg">
                      <div class="flex items-center gap-2">
                        <CheckCircleIcon v-if="server.link.sync_secundario === 'on'" class="h-5 w-5 text-green-400" />
                        <RefreshCwOff v-else class="h-5 w-5 text-red-400" />
                        <span class="text-white font-medium text-base">Link Secundário</span>
                      </div>
                      <span class="text-gray-300 text-base">{{ server.link.secondaryIP }}</span>
                    </div>
                  </template>
                  <div v-else class="text-center py-3 text-gray-400">
                    <Globe class="h-6 w-6 mx-auto mb-2 opacity-50" />
                    <span class="text-base">Sem link</span>
                  </div>
                </div>
              </div>
              <!-- Download/Upload -->
              <div class="flex flex-col justify-between bg-white/10 rounded-xl border border-white/20 p-4">
                <div class="flex-1 flex flex-col justify-center gap-6">
                  <div class="flex items-center gap-3 justify-center">
                    <ArrowDownIcon class="h-7 w-7 text-green-400" />
                    <span class="text-2xl font-bold text-white">{{ formatNetworkSpeed(server.net_down) }}</span>
                  </div>
                  <div class="flex items-center gap-3 justify-center">
                    <ArrowUpIcon class="h-7 w-7 text-blue-400" />
                    <span class="text-2xl font-bold text-white">{{ formatNetworkSpeed(server.net_up) }}</span>
                  </div>
                </div>
              </div>
            </div>

            <!-- Métricas de Sistema -->
            <div class="grid grid-cols-2 gap-4 mb-6">
              <!-- CPU -->
              <div class="text-center bg-white/5 rounded-xl p-4">
                <div class="relative w-28 h-28 mx-auto mb-3">
                  <Doughnut :data="getCpuChartData(server)" :options="getKioskSmallChartOptions()" />
                  <div class="absolute inset-0 flex items-center justify-center">
                    <span class="text-2xl font-bold text-white">{{ server.cpu_percent }}%</span>
                  </div>
                </div>
                <div class="text-lg text-gray-300 font-bold">CPU</div>
              </div>

              <!-- Memória -->
              <div class="text-center bg-white/5 rounded-xl p-4">
                <div class="relative w-28 h-28 mx-auto mb-3">
                  <Doughnut :data="getMemoryChartData(server)" :options="getKioskSmallChartOptions()" />
                  <div class="absolute inset-0 flex items-center justify-center">
                    <span class="text-2xl font-bold text-white">{{ server.mem_percent }}%</span>
                  </div>
                </div>
                <div class="text-lg text-gray-300 font-bold">RAM</div>
              </div>
            </div>

            <!-- Discos -->
            <div v-if="server.disks && Object.keys(server.disks).length > 0" class="mb-6">
              <h4 class="text-xl font-bold text-white mb-3 text-center">Discos</h4>
              <div class="grid grid-cols-2 gap-3">
                <template v-for="(disk, mount) in server.disks" :key="mount">
                  <div class="text-center bg-white/5 rounded-lg p-3">
                    <div class="relative w-28 h-28 mx-auto mb-2">
                      <Doughnut :data="getDiskChartData(disk)" :options="getKioskSmallChartOptions()" />
                      <div class="absolute inset-0 flex items-center justify-center">
                        <span class="text-2xl font-bold text-white">{{ disk.percent }}%</span>
                      </div>
                    </div>
                    <div class="text-base text-gray-300 truncate">{{ mount }}</div>
                  </div>
                </template>
              </div>
            </div>
            <template v-else>
              <div class="mb-6 text-center bg-white/5 rounded-xl p-4">
                <div class="relative w-28 h-28 mx-auto mb-3">
                  <Doughnut :data="getEmptyDiskChartData()" :options="getKioskSmallChartOptions()" />
                  <div class="absolute inset-0 flex items-center justify-center">
                    <span class="text-2xl font-bold text-white">0%</span>
                  </div>
                </div>
                <div class="text-lg text-gray-300 font-bold">Disco</div>
              </div>
            </template>

            <!-- Serviços e Alertas -->
            <div class="grid grid-cols-2 gap-4 mt-2">
              <div class="bg-white/5 rounded-xl p-6 flex flex-col items-center justify-center min-h-[90px]">
                <div class="flex items-center gap-3 mb-2">
                  <SettingsIcon class="h-6 w-6 text-purple-400" />
                  <span class="text-lg text-gray-300 font-bold">Serviços</span>
                </div>
                <div :class="countStoppedServices(server.services) > 0 ? 'text-red-400 font-bold text-xl' : 'text-green-400 text-xl'">
                  {{ countStoppedServices(server.services) }} parado(s)
                </div>
              </div>
              <div class="bg-white/5 rounded-xl p-6 flex flex-col items-center justify-center min-h-[90px]">
                <div class="flex items-center gap-3 mb-2">
                  <AlertTriangleIcon class="h-6 w-6 text-yellow-400" />
                  <span class="text-lg text-gray-300 font-bold">Alertas</span>
                </div>
                <div :class="hasWarnings(server) ? 'text-yellow-400 font-bold text-xl' : 'text-green-400 text-xl'">
                  {{ hasWarnings(server) ? 'Ativo' : 'Nenhum' }}
                </div>
              </div>
            </div>
          </template>
          
          <!-- Servidor offline -->
          <template v-else>
            <div class="flex items-center justify-center h-64 border-2 border-dashed border-red-500/30 rounded-lg">
              <div class="text-center">
                <XCircleIcon class="h-16 w-16 text-red-500 mx-auto mb-4" />
                <span class="text-2xl font-bold text-red-400">OFFLINE</span>
                <div class="text-gray-400 mt-2">Servidor indisponível</div>
              </div>
            </div>
          </template>
        </div>
      </div>

      <!-- Controles do Kiosk -->
      <div class="fixed top-4 right-4 flex gap-2">
        <button @click="toggleKioskMode"
          class="px-4 py-2 rounded-lg border font-medium transition-all flex items-center gap-2 bg-red-600 text-white border-red-600 dark:border-red-500 hover:bg-red-700">
          <minimize-2-icon class="h-4 w-4" />          
        </button>
      </div>
    </div>
  </div>
  
  <!-- Modais e outros elementos permanecem iguais -->
  <div v-if="showServicesModal" class="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40">
    <div class="bg-white dark:bg-gray-800 rounded-xl shadow-lg max-w-lg w-full p-6 relative">
      <button @click="closeServicesModal"
        class="absolute top-3 right-3 text-gray-500 hover:text-gray-900 dark:hover:text-white text-xl">&times;</button>
      <h2 class="text-lg font-bold mb-4 text-gray-900 dark:text-white">Serviços de {{ modalServerName }}</h2>
      <div class="max-h-96 overflow-y-auto divide-y divide-gray-200 dark:divide-gray-700">
        <div v-for="(service, name) in modalServices" :key="name" class="flex justify-between py-2">
          <span class="text-gray-800 dark:text-gray-200 truncate" :title="name">{{ name }}</span>
          <span :class="{
            'text-green-600 dark:text-green-400': service.status === 'running',
            'text-red-600 dark:text-red-400 font-semibold': service.status === 'stopped',
            'text-gray-500 dark:text-gray-400': service.status !== 'running' && service.status !== 'stopped'
          }" class="font-medium">
            {{ service.status }}
          </span>
        </div>
      </div>
      <div class="mt-6 text-right">
        <button @click="closeServicesModal"
          class="px-4 py-2 rounded-lg bg-blue-600 text-white hover:bg-blue-700 transition">Fechar</button>
      </div>
    </div>
  </div>
  
  <Transition name="fade">
    <div v-if="banner.show" :class="[
      'fixed top-4 left-1/2 transform -translate-x-1/2 z-50 px-6 py-3 rounded-lg shadow-lg flex items-center gap-3',
      banner.type === 'alert'
        ? 'bg-red-600 text-white'
        : 'bg-green-600 text-white'
    ]" style="min-width: 320px; max-width: 90vw;">
      <AlertTriangleIcon v-if="banner.type === 'alert'" class="h-5 w-5" />
      <CheckCircleIcon v-else class="h-5 w-5" />
      <span class="font-semibold">{{ banner.message }}</span>
    </div>
  </Transition>
  
  <button @click="toggleAudio" :class="[
    'hidden sm:flex fixed bottom-6 right-6 z-50 rounded-full shadow-lg px-4 py-2 text-sm flex items-center gap-2 transition-all',
    audioEnabled
      ? 'bg-red-600 hover:bg-red-700 text-white'
      : 'bg-green-600 hover:bg-green-700 text-white'
  ]" style="box-shadow: 0 2px 8px rgba(0,0,0,0.15);"
    :title="audioEnabled ? 'Desativar sons do sistema' : 'Ativar sons do sistema'">
    <VolumeXIcon v-if="audioEnabled" class="h-4 w-4" />
    <Volume2Icon v-else class="h-4 w-4" />
    {{ audioEnabled ? 'Desativar sons' : 'Ativar sons' }}
  </button>

  <div v-if="currentView === 'general'" class="flex justify-center items-center mb-8">
    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
      <!-- Gráfico de status geral -->
      <div class="bg-white dark:bg-gray-800 rounded-2xl p-6 shadow">
        <h3 class="text-2xl font-bold mb-4 text-center">Status Geral</h3>
        <div class="h-64 relative">
          <Doughnut :data="filteredStatusChartData" :options="kioskChartOptions" />
        </div>
        <div class="mt-4 text-center">
          <div class="text-3xl font-bold">{{ filteredTotalServers }}</div>
          <div class="text-gray-500 dark:text-gray-300">Total de Servidores</div>
        </div>
      </div>
      <!-- Gráfico de CPU média -->
      <div class="bg-white dark:bg-gray-800 rounded-2xl p-6 shadow">
        <h3 class="text-2xl font-bold mb-4 text-center">CPU Média</h3>
        <div class="h-64">
          <Line :data="cpuTrendData" :options="kioskLineChartOptions" />
        </div>
        <div class="mt-4 text-center">
          <div class="text-3xl font-bold">{{ averageCpu }}%</div>
          <div class="text-gray-500 dark:text-gray-300">Uso Médio</div>
        </div>
      </div>
      <!-- Gráfico de memória por servidor -->
      <div class="bg-white dark:bg-gray-800 rounded-2xl p-6 shadow">
        <h3 class="text-2xl font-bold mb-4 text-center">Memória por Servidor</h3>
        <div class="h-64">
          <Bar :data="memoryChartData" :options="kioskBarChartOptions" />
        </div>
        <div class="mt-4 text-center">
          <div class="text-3xl font-bold">{{ averageMemory }}%</div>
          <div class="text-gray-500 dark:text-gray-300">Média Geral</div>
        </div>
      </div>
    </div>
  </div>

  <!-- Modal de Edição do Nome -->
  <div v-if="showEditModal" class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50" @click="closeEditModal">
    <div class="bg-white dark:bg-gray-800 rounded-lg p-6 w-96 max-w-[90vw]" @click.stop>
      <h3 class="text-lg font-semibold mb-4 text-gray-900 dark:text-white">Editar Nome do Servidor</h3>
      
      <div class="mb-4">
        <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
          Nome Personalizado
        </label>
        <input 
          v-model="editingDisplayName" 
          @keyup.enter="saveDisplayName"
          @keyup.escape="closeEditModal"
          class="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 bg-white dark:bg-gray-700 text-gray-900 dark:text-white"
          :placeholder="currentServer?.display_name || currentServer?.unidade_nome || currentServer?.hostname || 'Nome do servidor'"
          ref="modalInput"
        />
        <p class="text-xs text-gray-500 dark:text-gray-400 mt-1">
          Deixe em branco para usar o nome padrão: {{ currentServer?.display_name || currentServer?.unidade_nome || currentServer?.hostname }}
        </p>
      </div>
      
      <div class="flex justify-end gap-3">
        <button 
          @click="closeEditModal"
          class="px-4 py-2 text-gray-600 dark:text-gray-400 hover:text-gray-800 dark:hover:text-gray-200 transition-colors"
        >
          Cancelar
        </button>
        <button 
          @click="saveDisplayName"
          class="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors"
        >
          Salvar
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
import BaseTemplate from '../templates/BaseTemplate.vue';
import UnidadeLinkCard from '@/components/UnidadeLinkCard.vue';
import { ref, computed, onMounted, onUnmounted, watch, nextTick } from 'vue';
import apiClient from '@/services/authService';

// Importações do Chart.js
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  Title,
  Tooltip,
  Legend,
  ArcElement
} from 'chart.js'
import { Doughnut, Line, Bar } from 'vue-chartjs'

// Registrar componentes do Chart.js
ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  Title,
  Tooltip,
  Legend,
  ArcElement
)

import {
  ServerIcon, CpuIcon, HardDriveIcon, DatabaseIcon, WifiIcon, SettingsIcon,
  AlertTriangleIcon, CalendarIcon, KeyIcon, ArrowDownIcon, ArrowUpIcon,
  CheckCircleIcon, GridIcon, ListIcon, SearchIcon,
  MoreHorizontalIcon, ExternalLinkIcon, XCircleIcon, Maximize2Icon,
  Minimize2Icon, Globe,
  RefreshCw,
  RefreshCwOff,
  Volume2Icon,
  VolumeXIcon,
  Edit2,
 
 // BarIcon
} from 'lucide-vue-next';

const currentView = ref('overview');
const activeFilter = ref('all');
const activeTypeFilter = ref('all'); // Filtro para tipos de servidor
const activeHostFilter = ref('all'); // Filtro para hosts específicos
const searchQuery = ref('');
const isKioskMode = ref(false);
const currentTime = ref('');
const currentDate = ref('');

const currentPage = ref(0);
const cardsPerPage = ref(3);
const selectedServer = ref(null);
const kioskDisplayState = ref('overviewCharts'); // 'overviewCharts', 'overviewCards', 'linksView'

const REFRESH_INTERVAL = 60000; // 60 segundos (agentes reportam a cada ~60s; backend cacheia 60s)
const VIEW_ROTATION_INTERVAL = 10000;

let refreshTimer = null;
let viewRotationTimer = null;
let timeUpdateTimer = null;
let isFetching = false; // Flag para prevenir múltiplas execuções simultâneas

const servers = ref([]);
const hosts = ref([]); // Lista de hosts disponíveis
const showEditModal = ref(false);
const currentServer = ref(null);
const editingDisplayName = ref('');

// Computed properties para gráficos filtrados
const filteredWarningServers = computed(() => {
  return filteredServers.value.filter(server => {
    const effectiveStatus = getEffectiveStatus(server);
    const linkStatusText = getStatusTextForCard(server);
    const hasConfiguredLink = server.link && (server.link.primaryIP || server.link.secondaryIP);

    return effectiveStatus === 'warning' || (hasConfiguredLink && linkStatusText === 'Funcionamento Parcial');
  }).length;
});

const filteredOfflineServers = computed(() => {
  return filteredServers.value.filter(server => getEffectiveStatus(server) === 'offline').length;
});

// Dados dos gráficos Chart.js para o modo kiosk (baseados nos filtros)
const filteredStatusChartData = computed(() => ({
  labels: ['Online', 'Alerta', 'Offline'],
  datasets: [{
    data: [filteredOnlineServers.value, filteredWarningServers.value, filteredOfflineServers.value],
    backgroundColor: [
      'rgba(34, 197, 94, 0.8)',
      'rgba(251, 191, 36, 0.8)',
      'rgba(239, 68, 68, 0.8)'
    ],
    borderColor: [
      'rgba(34, 197, 94, 1)',
      'rgba(251, 191, 36, 1)',
      'rgba(239, 68, 68, 1)'
    ],
    borderWidth: 2
  }]
}))

const cpuTrendData = computed(() => ({
  labels: ['5min', '4min', '3min', '2min', '1min', 'Agora'],
  datasets: [{
    label: 'CPU Média (%)',
    data: [42, 45, 48, 46, 44, averageCpu.value],
    borderColor: 'rgba(59, 130, 246, 1)',
    backgroundColor: 'rgba(59, 130, 246, 0.1)',
    tension: 0.4,
    fill: true
  }]
}))

const memoryChartData = computed(() => ({
  labels: servers.value.map(s => (s.display_name || s.unidade_nome || s.hostname).substring(0, 8)),
  datasets: [{
    label: 'Memória (%)',
    data: servers.value.map(s => s.mem_percent),
    backgroundColor: servers.value.map(s => {
      const status = getEffectiveStatus(s)
      if (status === 'offline') return 'rgba(107, 114, 128, 0.8)'
      if (status === 'warning') return 'rgba(251, 191, 36, 0.8)'
      return 'rgba(34, 197, 94, 0.8)'
    }),
    borderColor: servers.value.map(s => {
      const status = getEffectiveStatus(s)
      if (status === 'offline') return 'rgba(107, 114, 128, 1)'
      if (status === 'warning') return 'rgba(251, 191, 36, 1)'
      return 'rgba(34, 197, 94, 1)'
    }),
    borderWidth: 2
  }]
}))

const averageCpu = computed(() => {
  const onlineServersList = servers.value.filter(s => getEffectiveStatus(s) !== 'offline')
  if (onlineServersList.length === 0) return 0
  return Math.round(onlineServersList.reduce((sum, s) => sum + s.cpu_percent, 0) / onlineServersList.length)
})

const averageMemory = computed(() => {
  const onlineServersList = servers.value.filter(s => getEffectiveStatus(s) !== 'offline')
  if (onlineServersList.length === 0) return 0
  return Math.round(onlineServersList.reduce((sum, s) => sum + s.mem_percent, 0) / onlineServersList.length)
})

// Opções dos gráficos Chart.js
const kioskChartOptions = {
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
    legend: {
      position: 'bottom',
      labels: {
        color: 'white',
        font: { size: 14 }
      }
    }
  }
}

const kioskLineChartOptions = {
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
    legend: { display: false }
  },
  scales: {
    x: {
      ticks: { color: 'white' },
      grid: { color: 'rgba(255, 255, 255, 0.1)' }
    },
    y: {
      ticks: { color: 'white' },
      grid: { color: 'rgba(255, 255, 255, 0.1)' },
      min: 0,
      max: 100
    }
  }
}

const kioskBarChartOptions = {
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
    legend: { display: false }
  },
  scales: {
    x: {
      ticks: { 
        color: 'white',
        maxRotation: 45
      },
      grid: { color: 'rgba(255, 255, 255, 0.1)' }
    },
    y: {
      ticks: { color: 'white' },
      grid: { color: 'rgba(255, 255, 255, 0.1)' },
      min: 0,
      max: 100
    }
  }
}

// Funções para gerar dados dos gráficos individuais
const getCpuChartData = (server) => ({
  datasets: [{
    data: [server.cpu_percent, 100 - server.cpu_percent],
    backgroundColor: [
      server.cpu_percent > 80 ? 'rgba(239, 68, 68, 0.8)' : 
      server.cpu_percent > 60 ? 'rgba(251, 191, 36, 0.8)' : 'rgba(34, 197, 94, 0.8)',
      'rgba(255, 255, 255, 0.1)'
    ],
    borderWidth: 0
  }]
})

const getMemoryChartData = (server) => ({
  datasets: [{
    data: [server.mem_percent, 100 - server.mem_percent],
    backgroundColor: [
      server.mem_percent > 85 ? 'rgba(239, 68, 68, 0.8)' : 
      server.mem_percent > 70 ? 'rgba(251, 191, 36, 0.8)' : 'rgba(34, 197, 94, 0.8)',
      'rgba(255, 255, 255, 0.1)'
    ],
    borderWidth: 0
  }]
})

const getDiskChartData = (disk) => {
  const diskPercent = disk?.percent || 0
  return {
    datasets: [{
      data: [diskPercent, 100 - diskPercent],
      backgroundColor: [
        diskPercent > 90 ? 'rgba(239, 68, 68, 0.8)' : 
        diskPercent > 75 ? 'rgba(251, 191, 36, 0.8)' : 'rgba(34, 197, 94, 0.8)',
        'rgba(255, 255, 255, 0.1)'
      ],
      borderWidth: 0
    }]
  }
}

const getEmptyDiskChartData = () => ({
  datasets: [{
    data: [0, 100],
    backgroundColor: [
      'rgba(107, 114, 128, 0.8)',
      'rgba(255, 255, 255, 0.1)'
    ],
    borderWidth: 0
  }]
})

const getKioskChartOptions = () => ({
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
    legend: { display: false },
    tooltip: { enabled: false }
  },
  cutout: '70%'
})

const getKioskSmallChartOptions = () => ({
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
    legend: { display: false },
    tooltip: { enabled: false }
  },
  cutout: '70%'
})

// Funções auxiliares para o modo kiosk
const updateTime = () => {
  const now = new Date()
  currentTime.value = now.toLocaleTimeString('pt-BR')
  currentDate.value = now.toLocaleDateString('pt-BR', {
    weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  })
}


const getKioskStatusText = (server) => {
  const status = getEffectiveStatus(server)
  switch (status) {
    case 'online': return 'Funcionamento Normal'
    case 'warning': return 'Atenção Necessária'
    case 'offline': return 'Fora de Operação'
    default: return 'Status Desconhecido'
  }
}

const getKioskStatusIndicatorClass = (server) => {
  const status = getEffectiveStatus(server)
  switch (status) {
    case 'online': return 'bg-green-500'
    case 'warning': return 'bg-yellow-500'
    case 'offline': return 'bg-red-500'
    default: return 'bg-gray-500'
  }
}

const getKioskServerBorderClass = (server) => {
  const status = getEffectiveStatus(server)
  switch (status) {
    case 'online': return 'border-green-500/50 shadow-green-500/20 shadow-lg'
    case 'warning': return 'border-yellow-500/50 shadow-yellow-500/20 shadow-lg'
    case 'offline': return 'border-red-500/50 shadow-red-500/20 shadow-lg'
    default: return 'border-white/10'
  }
}




const getKioskLinkStatusBadgeClass = (server) => {
  const link = server.link;
  if (!link || (typeof link !== 'object')) return 'bg-gray-500/30 text-gray-300 border border-gray-500/50';

  const hasPrimary = link.primaryIP && link.primaryIP !== 'N/A' && link.primaryIP !== '';
  const hasSecondary = link.secondaryIP && link.secondaryIP !== 'N/A' && link.secondaryIP !== '';
  const syncPrimario = link.sync_primario === 'on';
  const syncSecundario = link.sync_secundario === 'on';

  // Ambos links
  if (hasPrimary && hasSecondary) {
    if (syncPrimario && syncSecundario) return 'bg-green-500/30 text-green-300 border border-green-500/50';
    if (!syncPrimario && !syncSecundario) return 'bg-red-500/30 text-red-300 border border-red-500/50';
    return 'bg-yellow-500/30 text-yellow-300 border border-yellow-500/50';
  }
  // Apenas primário
  if (hasPrimary) {
    if (syncPrimario) return 'bg-green-500/30 text-green-300 border border-green-500/50';
    return 'bg-red-500/30 text-red-300 border border-red-500/50';
  }
  // Apenas secundário
  if (hasSecondary) {
    if (syncSecundario) return 'bg-green-500/30 text-green-300 border border-green-500/50';
    return 'bg-red-500/30 text-red-300 border border-red-500/50';
  }
  return 'bg-gray-500/30 text-gray-300 border border-gray-500/50';
}

const setActiveFilter = (filter) => {
  activeFilter.value = filter;
  selectedServer.value = null;
};

const setActiveTypeFilter = (typeFilter) => {
  activeTypeFilter.value = typeFilter;
  selectedServer.value = null;
};

const setActiveHostFilter = (hostFilter) => {
  // console.log('🎯 DEBUG - setActiveHostFilter chamado com:', hostFilter);
  // console.log('🎯 DEBUG - Hosts disponíveis:', hosts.value);
  activeHostFilter.value = hostFilter;
  selectedServer.value = null;
};

const setView = (viewName) => {
  currentView.value = viewName;
  selectedServer.value = null;
};

const selectServerForDetailedView = (server) => {
  selectedServer.value = server;
  currentView.value = 'detailed';
};

const detailedViewLoopServers = computed(() => {
  if (selectedServer.value && currentView.value === 'detailed') {
    return [selectedServer.value];
  }
  return isKioskMode.value ? currentPageServers.value : filteredServers.value;
});

const handleSearchInput = () => {
  selectedServer.value = null;
};

const countStoppedServices = (servicesObject) => {
  if (!servicesObject || typeof servicesObject !== 'object') {
    return 0;
  }
  return Object.values(servicesObject).filter(service => service.status === 'stopped').length;
};

const getActiveIP = (server) => {
  const link = server?.link;
  if (!link || Object.keys(link).length === 0 || !link.status) return 'N/A';

  switch (link.status) {
    case 1: // Ambos online, prioridade primário
    case 2: // Apenas primário online
      return link.primaryIP || 'N/A Primário';
    case 3: // Apenas secundário online
      return link.secondaryIP || 'N/A Secundário';
    case 4: // Ambos offline
    default:
      return 'LINK OFF';
  }
};

const openServerLink = (server) => {
  const dns = server?.link?.dns;
  if (dns) {
    window.open(`https://${dns}/Place`, '_blank');
  } else {
    console.warn('DNS não disponível para este servidor.');
    alert('DNS não disponível para este servidor.');
  }
};

const openEditModal = (server) => {
  currentServer.value = server;
  editingDisplayName.value = server.display_name || '';
  showEditModal.value = true;
  // Focar no input após o modal abrir
  nextTick(() => {
    const input = document.querySelector('input[ref="modalInput"]');
    if (input) input.focus();
  });
};

const closeEditModal = () => {
  showEditModal.value = false;
  currentServer.value = null;
  editingDisplayName.value = '';
};

const saveDisplayName = async () => {
  if (!currentServer.value) return;
  
  try {
    // Chamar a API para salvar o nome de exibição no banco de dados
    const response = await apiClient.patch(`/api/v1/guardian/update-display-name/${currentServer.value.token}`, null, {
      params: {
        display_name: editingDisplayName.value || null
      }
    });
    
    if (response.data.ok) {
      // Atualizar localmente após sucesso na API
      currentServer.value.display_name = editingDisplayName.value;
      closeEditModal();
    } else {
      console.error('Resposta da API não foi bem-sucedida:', response.data);
      alert(`Erro ao salvar: ${response.data.message || 'Resposta inválida da API'}`);
    }
  } catch (error) {
    console.error('Erro ao salvar nome de exibição:', error);
    const errorMessage = error.response?.data?.message || error.response?.data?.detail || error.message || 'Erro desconhecido';
    alert(`Erro ao salvar nome de exibição: ${errorMessage}`);
  }
};

const fetchInventoryServers = async () => {
  try {
    const response = await apiClient.get('/api/v1/inventoryit/servidores/');
    return response.data || [];
  } catch (error) {
    console.error('Erro ao buscar dados do InventoryIt:', error);
    return [];
  }
};

const fetchHosts = async () => {
  try {
    const response = await apiClient.get('/api/v1/inventoryit/hosts/');
    return response.data || [];
  } catch (error) {
    console.error('Erro ao buscar hosts do InventoryIt:', error);
    return [];
  }
};

const fetchGuardianInfo = async () => {
  // Prevenir múltiplas execuções simultâneas
  if (isFetching) {
    console.log('Fetch já em andamento, ignorando nova requisição');
    return;
  }
  
  isFetching = true;
  
  try {
    // Buscar todos os dados do Guardian com paginação
    let allGuardianData = [];
    let currentPage = 1;
    let hasMorePages = true;
    
    while (hasMorePages) {
      const guardianResponse = await apiClient.get('/api/v1/guardian/info', {
        params: {
          page: currentPage,
          page_size: 100 // Usar um tamanho de página maior para reduzir o número de requisições
        }
      });
      
      const responseData = guardianResponse.data;
      const guardianData = responseData.guardian_metrics || [];
      
      allGuardianData = allGuardianData.concat(guardianData);
      
      // Verificar se há mais páginas
      if (responseData.pagination) {
        hasMorePages = responseData.pagination.has_next;
        currentPage++;
      } else {
        // Fallback para compatibilidade com versão anterior (sem paginação)
        hasMorePages = false;
      }
    }
    
    const guardianData = allGuardianData;
    
    // Buscar dados do InventoryIt
    const inventoryData = await fetchInventoryServers();
    
    // Buscar hosts disponíveis
    const hostsData = await fetchHosts();
    hosts.value = hostsData;
    
    // Debug: verificar tokens disponíveis
    // console.log('Tokens no Guardian:', guardianData.map(s => s.token));
    // console.log('Tokens no InventoryIt:', inventoryData.map(s => s.token));
    
    // Criar um mapa dos dados do InventoryIt por token, hostname e service_tag para facilitar a busca
    const inventoryMap = new Map();
    inventoryData.forEach(server => {
      if (server.token) {
        inventoryMap.set(server.token, server);
      }
      if (server.hostname) {
        inventoryMap.set(server.hostname, server);
      }
      if (server.service_tag) {
        inventoryMap.set(server.service_tag, server);
      }
    });

    servers.value = guardianData.map(s => {
      // Tentar encontrar dados correspondentes no InventoryIt por token primeiro, depois hostname/service_tag
      const inventoryServer = inventoryMap.get(s.token) || inventoryMap.get(s.hostname) || inventoryMap.get(s.service_tag) || {};
      
      return {
        ...s,
        disks: s.disks || {},
        link: s.link || null,
        unidade_nome: s.link?.unidade_nome,
        location: s.location || 'N/A',
        cpu_model: s.cpu_model || 'N/A',
        cpu_cores: s.cpu_cores,
        cpu_temp: s.cpu_temp,
        cpu_load: s.cpu_load,
        latency: s.latency,
        cpu_percent: s.cpu_percent ?? 0,
        mem_percent: s.mem_percent ?? 0,
        mem_total: s.mem_total ?? 0,
        net_down: s.net_down ?? 0,
        net_up: s.net_up ?? 0,
        uptime: s.uptime ?? 0,
        services: s.services || {},
        last_backup: s.last_backup || "N/A",
        pending_updates: s.pending_updates || "N/A",
        token: s.token || "N/A",
        // Preservar o display_name que vem da API do Guardian
        display_name: s.display_name || null,
        // Adicionar dados do InventoryIt
        tipo: inventoryServer.tipo_nome || inventoryServer.tipo || '',
        tipo_nome: inventoryServer.tipo_nome || inventoryServer.tipo || '',
        modelo_nome: inventoryServer.modelo_nome || '',
        marca_nome: inventoryServer.marca_nome || '',
        serial_number: inventoryServer.serial_number || s.service_tag || '',
        // Campos de host para filtragem
        host_id: inventoryServer.host_id || null,
        host_nome: inventoryServer.host_nome || null
      };
    });
  } catch (error) {
    console.error('Erro ao buscar dados do Guardian:', error);
  } finally {
    // Sempre resetar a flag, mesmo em caso de erro
    isFetching = false;
  }
};

onMounted(() => {
  fetchGuardianInfo();
  updateTime();
  timeUpdateTimer = setInterval(updateTime, 1000);
  
  const storedAudioEnabled = localStorage.getItem('audioEnabled');
  if (storedAudioEnabled === 'true') {
    audioEnabled.value = true;
  }
  const stopInitWatch = watch(servers, (val) => {
    if (val && val.length > 0) {
      initialized.value = true;
      stopInitWatch();
    }
  }, { immediate: true });

  if ('speechSynthesis' in window) {
    loadVoices();
    if (window.speechSynthesis.onvoiceschanged !== undefined) {
      window.speechSynthesis.onvoiceschanged = loadVoices;
    } else {
      setTimeout(loadVoices, 500);
    }
  }
});

const toggleKioskMode = () => {
  isKioskMode.value = !isKioskMode.value;
  if (isKioskMode.value) {
    selectedServer.value = null;
    startKioskMode();
  } else {
    stopKioskMode();
  }
};

const startKioskMode = () => {
  currentPage.value = 0;
  kioskDisplayState.value = 'overviewCards';

  // Limpar timers existentes antes de criar novos
  if (refreshTimer) {
    clearInterval(refreshTimer);
  }
  if (viewRotationTimer) {
    clearInterval(viewRotationTimer);
  }

  refreshTimer = setInterval(async () => {
    if (document.hidden) return; // aba em segundo plano: não consome API
    await fetchGuardianInfo();
  }, REFRESH_INTERVAL);

  viewRotationTimer = setInterval(() => {
    if (totalPages.value > 0) {
      const nextPageIndex = (currentPage.value + 1);
      if (nextPageIndex >= totalPages.value) {
        currentPage.value = 0;
      } else {
        currentPage.value = nextPageIndex;
      }
    } else {
      currentPage.value = 0;
    }
  }, VIEW_ROTATION_INTERVAL);

  const element = document.documentElement;
  if (element && element.requestFullscreen && !document.fullscreenElement) {
    element.requestFullscreen().catch(() => { });
  }
};

const stopKioskMode = () => {
  if (refreshTimer) {
    clearInterval(refreshTimer);
    refreshTimer = null;
  }
  if (viewRotationTimer) {
    clearInterval(viewRotationTimer);
    viewRotationTimer = null;
  }

  if (document.fullscreenElement && document.exitFullscreen) {
    document.exitFullscreen().catch(() => { });
  }
};

onUnmounted(() => {
  stopKioskMode();
  if (timeUpdateTimer) {
    clearInterval(timeUpdateTimer);
  }
});

function getEffectiveStatus(server) {
  if (!server) {
    return 'offline';
  }

  const networkStatus = (server?.network_status || '').toLowerCase();
  const hasCpuData = server.cpu_percent !== undefined && server.cpu_percent !== null;

  // Para servidores VM e Host, não considerar validação de links no status
  const serverType = server?.tipo_nome || server?.tipo || server?.type || '';
  const isVMOrHost = serverType === 'Servidor - VM' || serverType === 'Servidor - Host';

  // Sem telemetria de atividade, permanece offline.
  if (!hasCpuData && networkStatus !== 'online') {
    return 'offline';
  }

  // Link totalmente fora deve sinalizar alerta (nao derruba para offline se ha telemetria).
  if (!isVMOrHost) {
    const hasLinkConfig = server.link && (server.link.primaryIP || server.link.secondaryIP);
    if (hasLinkConfig && getStatusTextForCard(server) === 'Fora de Operação') {
      return 'warning';
    }
  }

  if (server.cpu_percent > 80) {
    return 'warning';
  }
  if (server.mem_percent > 85) {
    return 'warning';
  }
  if (server.disks && Object.values(server.disks).some(disk => disk.percent > 90)) {
    return 'warning';
  }
  if (countStoppedServices(server.services) > 0) {
    return 'warning';
  }
  
  // Para servidores VM e Host, não considerar status de link no warning
  if (!isVMOrHost) {
    const hasLinkConfig = server.link && (server.link.primaryIP || server.link.secondaryIP);
    if (hasLinkConfig && getStatusTextForCard(server) === 'Funcionamento Parcial') {
      return 'warning';
    }
  }
  
  return 'online';
}

// Computed properties dinâmicas baseadas nos filtros aplicados
const filteredTotalServers = computed(() => {
  return filteredServers.value.length;
});

const filteredOnlineServers = computed(() => {
  return filteredServers.value.filter(server => {
    const effectiveStatus = getEffectiveStatus(server);
    const linkStatusText = getStatusTextForCard(server);
    const hasConfiguredLink = server.link && (server.link.primaryIP || server.link.secondaryIP);
    
    return effectiveStatus === 'online' && (!hasConfiguredLink || linkStatusText === 'Pleno Funcionamento');
  }).length;
});

const filteredActiveAlerts = computed(() => {
  return filteredServers.value.filter(server => {
    const status = getEffectiveStatus(server);
    const linkText = getStatusTextForCard(server);
    const hasConfiguredLink = server.link && (server.link.primaryIP || server.link.secondaryIP);

    return status === 'warning' ||
      (hasConfiguredLink && linkText === 'Funcionamento Parcial') ||
      (countStoppedServices(server.services) > 0) ||
      server.cpu_percent > 80 ||
      server.mem_percent > 85 ||
      (server.disks && Object.values(server.disks).some(disk => disk.percent > 90));
  }).length;
});

// Mantendo as computed properties originais para compatibilidade com gráficos e outras funcionalidades
const onlineServers = computed(() => {
  return servers.value.filter(server => getEffectiveStatus(server) === 'online').length;
});

const warningServers = computed(() => {
  return servers.value.filter(server => {
    const effectiveStatus = getEffectiveStatus(server);
    const linkStatusText = getStatusTextForCard(server);
    const hasConfiguredLink = server.link && (server.link.primaryIP || server.link.secondaryIP);

    return effectiveStatus === 'warning' || (hasConfiguredLink && linkStatusText === 'Funcionamento Parcial');
  }).length;
});

const offlineServers = computed(() => {
  return servers.value.filter(server => getEffectiveStatus(server) === 'offline').length;
});

const kioskTitle = computed(() => {
  // Se há um filtro de host específico aplicado
  if (activeHostFilter.value !== 'all') {
    const selectedHost = hosts.value.find(host => 
      host.id.toString() === activeHostFilter.value || 
      host.nome === activeHostFilter.value
    );
    const hostName = selectedHost ? selectedHost.nome : activeHostFilter.value;
    return `Monitorando Host - ${hostName}`;
  }
  
  // Filtros por tipo de servidor
  if (activeTypeFilter.value === 'all') {
    return 'Monitor de Servidores';
  } else if (activeTypeFilter.value === 'Servidor - Avançada') {
    return 'Monitor de Servidores Avançadas';
  } else if (activeTypeFilter.value === 'Servidor - VM') {
    return 'Monitor de Servidores VM';
  } else if (activeTypeFilter.value === 'Servidor - Host') {
    return 'Monitor de Servidores Host';
  }
  return 'Monitor de Servidores';
});

const filteredServers = computed(() => {
  let result = [...servers.value];
  
  // Filtro por host específico - APLICADO PRIMEIRO para garantir independência do tipo
  if (activeHostFilter.value !== 'all') {
    result = result.filter(server => {
      // Verificar se o servidor está associado ao host selecionado
      // Pode ser por host_id, host_nome, ou hostname
      const matchById = server.host_id === parseInt(activeHostFilter.value) || server.host_id?.toString() === activeHostFilter.value;
      const matchByName = server.host_nome === activeHostFilter.value;
      const matchByHostname = server.hostname === activeHostFilter.value;
      
      return matchById || matchByName || matchByHostname;
    });
  }
  
  // Filtro por status
  if (activeFilter.value !== 'all') {
    result = result.filter(server => {
      const effectiveStatus = getEffectiveStatus(server);
      const linkStatusText = getStatusTextForCard(server);
      const hasConfiguredLink = server.link && (server.link.primaryIP || server.link.secondaryIP);

      if (activeFilter.value === 'online') {
        return effectiveStatus === 'online' && (!hasConfiguredLink || linkStatusText === 'Pleno Funcionamento');
      }
      if (activeFilter.value === 'warning') {
        return effectiveStatus === 'warning' || (hasConfiguredLink && linkStatusText === 'Funcionamento Parcial');
      }
      if (activeFilter.value === 'offline') {
        return effectiveStatus === 'offline' || (hasConfiguredLink && linkStatusText === 'Fora de Operação');
      }
      return false;
    });
  }
  
  // Filtro por tipo de servidor - APLICADO APÓS o filtro de host
  // Só aplica o filtro de tipo se não há filtro de host ativo, ou se há filtro de host mas também há filtro de tipo
  if (activeTypeFilter.value !== 'all' && activeHostFilter.value === 'all') {
    result = result.filter(server => {
      // O tipo está disponível em server.tipo_nome (da API InventoryIt) ou server.tipo/server.type (Guardian)
      const serverType = server.tipo_nome || server.tipo || server.type || '';
      return serverType === activeTypeFilter.value;
    });
  }
  
  // Filtro por busca
  if (searchQuery.value.trim() !== '') {
    const query = searchQuery.value.toLowerCase();
    result = result.filter(server =>
      (server.display_name || '').toLowerCase().includes(query) ||
      (server.hostname || '').toLowerCase().includes(query) ||
      (server.unidade_nome || '').toLowerCase().includes(query) ||
      (server.location || '').toLowerCase().includes(query) ||
      (server.cpu_model || '').toLowerCase().includes(query)
    );
  }
  
  return result;
});

const criticalAlerts = computed(() => {
  return servers.value.filter(server => {
    const hasConfiguredLink = server.link && (server.link.primaryIP || server.link.secondaryIP);
    return getEffectiveStatus(server) === 'offline' ||
      (hasConfiguredLink && (server.link?.status === 4 || getStatusTextForCard(server) === 'Fora de Operação')) ||
      server.cpu_percent > 90 ||
      server.mem_percent > 90 ||
      (server.disks && Object.values(server.disks).some(disk => disk.percent > 95)) ||
      (countStoppedServices(server.services) > 0 && (
        (hasConfiguredLink && (server.link?.status === 4 || getStatusTextForCard(server) === 'Fora de Operação')) ||
        getEffectiveStatus(server) === 'offline'
      ));
  }).length;
});

const formatBytes = (bytes, decimals = 2) => {
  if (bytes === null || bytes === undefined || isNaN(bytes)) return '0 Bytes';
  if (bytes === 0) return '0 Bytes';
  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB'];
  const i = Math.min(Math.floor(Math.log(Math.abs(bytes)) / Math.log(k)), sizes.length - 1);
  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
};

const formatNetworkSpeed = (speed) => {
  if (speed === null || speed === undefined || isNaN(speed)) return '0 MB/s';
  if (speed < 1024) {
    return speed.toFixed(1) + ' MB/s';
  } else if (speed < 1024 * 1024) {
    return (speed / 1024).toFixed(1) + ' GB/s';
  } else {
    return (speed / 1024 / 1024).toFixed(2) + ' TB/s';
  }
};

const formatUptime = (seconds) => {
  if (seconds === null || seconds === undefined || isNaN(seconds)) return 'N/A';
  const d = Math.floor(seconds / (3600 * 24));
  const h = Math.floor(seconds % (3600 * 24) / 3600);
  const m = Math.floor(seconds % 3600 / 60);

  if (d > 0) return `${d}d ${h}h`;
  if (h > 0) return `${h}h ${m}m`;
  return `${m}m`;
};

const getGaugeColor = (percent, serverStatus) => {
  if (serverStatus === 'offline') {
    return 'offline-gauge-arc';
  }
  const p = parseFloat(percent);
  if (p < 60) return 'stroke-green-500 dark:stroke-green-400';
  if (p < 80) return 'stroke-yellow-500 dark:stroke-yellow-400';
  return 'stroke-red-500 dark:stroke-red-400';
};

const getUsageBadgeClass = (percent) => {
  const p = parseFloat(percent);
  if (p < 60) return 'bg-green-100 dark:bg-green-900/30 text-green-700 dark:text-green-400';
  if (p < 80) return 'bg-yellow-100 dark:bg-yellow-900/30 text-yellow-700 dark:text-yellow-400';
  return 'bg-red-100 dark:bg-red-900/30 text-red-700 dark:text-red-400';
};

const hasWarnings = (server) => {
  const effectiveStatus = getEffectiveStatus(server);
  const linkStatusText = getStatusTextForCard(server);
  const hasConfiguredLink = server.link && (server.link.primaryIP || server.link.secondaryIP);

  return effectiveStatus === 'warning' ||
    (hasConfiguredLink && effectiveStatus === 'online' && linkStatusText === 'Funcionamento Parcial') ||
    countStoppedServices(server.services) > 0 ||
    server.cpu_percent > 80 ||
    server.mem_percent > 85 ||
    (server.disks && Object.values(server.disks).some(disk => disk.percent > 90));
};

const polarToCartesian = (centerX, centerY, radius, angleInDegrees) => {
  const angleInRadians = ((angleInDegrees - 90) * Math.PI) / 180.0;
  return {
    x: centerX + radius * Math.cos(angleInRadians),
    y: centerY + radius * Math.sin(angleInRadians)
  };
};

const describeArcGauge = (x, y, radius, percent) => {
  const p = parseFloat(percent);
  if (isNaN(p)) return "";
  const normalizedPercent = Math.min(Math.max(p, 0), 100);

  if (normalizedPercent === 0) return "";

  const startAngleVisual = -90;
  const endAngleVisual = startAngleVisual + (normalizedPercent * 3.6);

  const start = polarToCartesian(x, y, radius, endAngleVisual);
  const end = polarToCartesian(x, y, radius, startAngleVisual);

  const largeArcFlag = (endAngleVisual - startAngleVisual) <= 180 ? "0" : "1";

  if (normalizedPercent >= 99.99) {
    return `M ${x - radius},${y} a ${radius},${radius} 0 1,1 ${2 * radius},0 a ${radius},${radius} 0 1,1 ${-2 * radius},0`;
  }

  const d = [
    "M", end.x, end.y,
    "A", radius, radius, 0, largeArcFlag, 1, start.x, start.y
  ].join(" ");

  return d;
};

const currentPageServers = computed(() => {
  if (!isKioskMode.value) return filteredServers.value;

  const start = currentPage.value * cardsPerPage.value;
  return filteredServers.value.slice(start, start + cardsPerPage.value);
});

const totalPages = computed(() => {
  if (filteredServers.value.length === 0) return 1;
  return Math.ceil(filteredServers.value.length / cardsPerPage.value);
});

function getStatusTextForCard(server) {
  // Para servidores VM e Host, sempre retornar "Pleno Funcionamento" para links
  // Eles não precisam de validação de links
  const serverType = server?.tipo_nome || server?.tipo || server?.type || '';
  if (serverType === 'Servidor - VM' || serverType === 'Servidor - Host') {
    return 'Pleno Funcionamento';
  }

  if (!server || !server.link || Object.keys(server.link).length === 0 ||
    (!server.link.primaryIP && !server.link.secondaryIP && !server.link.status)) {
    return 'Pleno Funcionamento';
  }

  const status = server.link.status;
  const hasPrimary = typeof server.link.primaryIP === 'string' && server.link.primaryIP.trim() !== '' && server.link.primaryIP !== 'N/A';
  const hasSecondary = typeof server.link.secondaryIP === 'string' && server.link.secondaryIP.trim() !== '' && server.link.secondaryIP !== 'N/A';

  if (!hasPrimary && !hasSecondary) {
    return status === 4 ? 'Fora de Operação' : 'Pleno Funcionamento';
  }

  if (status === 1) {
    return 'Pleno Funcionamento';
  } else if (status === 2) {
    if (hasSecondary) return 'Funcionamento Parcial';
    return 'Pleno Funcionamento';
  } else if (status === 3) {
    if (hasPrimary) return 'Funcionamento Parcial';
    return 'Pleno Funcionamento';
  } else if (status === 4) {
    return 'Fora de Operação';
  }

  return 'Desconhecido';
}

const showServicesModal = ref(false);
const modalServices = ref({});
const modalServerName = ref('');

function openServicesModal(services, serverName) {
  modalServices.value = services;
  modalServerName.value = serverName;
  showServicesModal.value = true;
}
function closeServicesModal() {
  showServicesModal.value = false;
}

function getLinkGlobeColor(link, type) {
  if (!link || !link.status) return 'text-gray-500 dark:text-gray-400';

  if (type === 'primary') {
    if (!link.primaryIP || link.primaryIP === 'N/A') return 'text-gray-500 dark:text-gray-400';
    if (link.status === 1 || link.status === 2) return 'text-green-500 dark:text-green-400';
    return 'text-red-500 dark:text-red-400';
  }
  if (type === 'secondary') {
    if (!link.secondaryIP || link.secondaryIP === 'N/A') return 'text-gray-500 dark:text-gray-400';
    if (link.status === 1 || link.status === 3) return 'text-green-500 dark:text-green-400';
    return 'text-red-500 dark:text-red-400';
  }
  return 'text-gray-500 dark:text-gray-400';
}

let firstCheckDone = false;

const playAlertSound = () => {
  if (!audioEnabled.value) return;
  const audio = new Audio('/sounds/notification.mp3');
  audio.volume = 0.7;
  audio.play().catch(e => console.warn("Erro ao tocar som de alerta:", e));
};

const playOkSound = () => {
  if (!audioEnabled.value) return;
  const audio = new Audio('/sounds/ok.mp3');
  audio.volume = 0.7;
  audio.play().catch(e => console.warn("Erro ao tocar som de OK:", e));
};

const banner = ref({
  show: false,
  type: '',
  message: '',
});
let bannerTimeout = null;

let allVoices = [];

function loadVoices() {
  if ('speechSynthesis' in window) {
    allVoices = window.speechSynthesis.getVoices();
  }
}

function speakBanner(message) {
  if (!audioEnabled.value) return;

  if ('speechSynthesis' in window) {
    window.speechSynthesis.cancel();
    const utter = new SpeechSynthesisUtterance(message);
    utter.lang = 'pt-BR';
    utter.rate = 0.9;
    utter.pitch = 1.0;
    utter.volume = 0.8;

    if (allVoices.length === 0) {
      loadVoices();
    }

    let femaleVoice = null;
    if (allVoices.length > 0) {
      const preferredFemaleNames = [
        'maria', 'francisca', 'female', 'feminino', 'mulher',
        'camila', 'luciana', 'fernanda', 'google português do brasil'
      ];
      femaleVoice = allVoices.find(voice =>
        voice.lang === 'pt-BR' &&
        preferredFemaleNames.some(namePart => voice.name.toLowerCase().includes(namePart))
      );
      if (!femaleVoice) {
        femaleVoice = allVoices.find(voice => voice.lang === 'pt-BR');
      }
    }

    if (femaleVoice) {
      utter.voice = femaleVoice;
    }
    
    // Aguardar um pouco antes de falar para evitar sobreposição com sons
    setTimeout(() => {
      window.speechSynthesis.speak(utter);
    }, 300);
  }
}

function showBanner(type, message) {
  banner.value = { show: true, type, message };
  speakBanner(message);
  if (bannerTimeout) clearTimeout(bannerTimeout);
  bannerTimeout = setTimeout(() => {
    banner.value.show = false;
  }, 5000);
}

function getStatusGroup(status) {
  return status === 'online' ? 'ok' : 'alerta';
}

function getAlertReason(server) {
  const hasLinkObject = server.link && typeof server.link === 'object' && Object.keys(server.link).length > 0;
  const hasAnyConfiguredLink = hasLinkObject && (server.link.primaryIP || server.link.secondaryIP);

  if (hasAnyConfiguredLink) {
    if (!server.link.validation_date) {
      return 'sem comunicação recente do link';
    }
    const lastUpdate = new Date(server.link.validation_date);
    const now = new Date();
    const diffMinutes = (now.getTime() - lastUpdate.getTime()) / (1000 * 60);
    if (diffMinutes > 10) {
      return 'sem comunicação recente do link';
    }
    if (getStatusTextForCard(server) === 'Fora de Operação') {
      return 'link fora de operação';
    }
    if (getStatusTextForCard(server) === 'Funcionamento Parcial') {
      return 'link em funcionamento parcial';
    }
  }
  if (server.cpu_percent > 80) return 'CPU alta';
  if (server.mem_percent > 85) return 'memória cheia';
  if (server.disks && Object.values(server.disks).some(disk => disk.percent > 90)) return 'disco cheio';
  if (countStoppedServices(server.services) > 0) return 'serviço parado';

  if (!hasAnyConfiguredLink && getEffectiveStatus(server) !== 'online') {
    return 'problema de métrica não especificado';
  }

  return 'motivo desconhecido';
}

const checkForAlerts = () => {
  if (!initialized.value) return;

  const alertMsgs = [];
  const okMsgs = [];

  servers.value.forEach(server => {
    const id = server.id || server.hostname;
    const currentServerStatus = getEffectiveStatus(server);
    const nomeReferencia = server.display_name || server.unidade_nome ? `Unidade ${server.display_name || server.unidade_nome}` : `Servidor ${server.hostname}`;

    const prevServerState = previousCriticalStates.value[id] || {};
    const currentServerState = {
      status: currentServerStatus,
      ramCritical: server.mem_percent > 85,
      diskCritical: server.disks && Object.values(server.disks).some(disk => disk.percent > 90),
      primaryLinkUp: server.link?.primaryIP && server.link?.primaryIP !== 'N/A' && (server.link?.status === 1 || server.link?.status === 2),
      secondaryLinkUp: server.link?.secondaryIP && server.link?.secondaryIP !== 'N/A' && (server.link?.status === 1 || server.link?.status === 3),
      hasPrimaryLinkConfig: server.link?.primaryIP && server.link?.primaryIP !== 'N/A',
      hasSecondaryLinkConfig: server.link?.secondaryIP && server.link?.secondaryIP !== 'N/A',
      linkStatus: server.link?.status || 0,
      linkStatusText: getStatusTextForCard(server)
    };

    if (!firstCheckDone) {
      previousCriticalStates.value[id] = { ...currentServerState, generalStatus: currentServerStatus };
      return;
    }

    const prevGeneralStatus = prevServerState.generalStatus;
    const currentGeneralStatusGroup = getStatusGroup(currentServerStatus);
    const prevGeneralStatusGroup = getStatusGroup(prevGeneralStatus);

    // Verificar mudanças de status geral
    if (prevGeneralStatus !== currentServerStatus && prevGeneralStatus !== undefined) {
      if (currentGeneralStatusGroup === 'alerta' && prevGeneralStatusGroup === 'ok') {
        const motivo = getAlertReason(server);
        alertMsgs.push(`${nomeReferencia} entrou em alerta: ${motivo}.`);
        if (currentServerStatus === 'offline') {
          playAlertSound();
        }
      } else if (currentGeneralStatusGroup === 'ok' && prevGeneralStatusGroup === 'alerta') {
        okMsgs.push(`${nomeReferencia} voltou ao funcionamento.`);
        playOkSound();
      }
    }

    // Verificar mudanças de memória
    if (!prevServerState.ramCritical && currentServerState.ramCritical) {
      alertMsgs.push(`${nomeReferencia}: alerta de memória cheia!`);
      playAlertSound();
    } else if (prevServerState.ramCritical && !currentServerState.ramCritical) {
      okMsgs.push(`${nomeReferencia}: memória normalizada.`);
      playOkSound();
    }

    // Verificar mudanças de disco
    if (!prevServerState.diskCritical && currentServerState.diskCritical) {
      alertMsgs.push(`${nomeReferencia}: alerta de disco cheio!`);
      playAlertSound();
    } else if (prevServerState.diskCritical && !currentServerState.diskCritical) {
      okMsgs.push(`${nomeReferencia}: uso de disco normalizado.`);
      playOkSound();
    }

    // Verificar mudanças de link primário
    if (currentServerState.hasPrimaryLinkConfig) {
      if (prevServerState.primaryLinkUp === true && !currentServerState.primaryLinkUp) {
        alertMsgs.push(`${nomeReferencia}: Link primário não acessível.`);
        playAlertSound();
      } else if (prevServerState.primaryLinkUp === false && currentServerState.primaryLinkUp) {
        if (currentServerStatus !== 'online' || prevGeneralStatus !== 'warning') {
          okMsgs.push(`${nomeReferencia}: Link primário restabelecido.`);
          playOkSound();
        }
      }
    }

    // Verificar mudanças de link secundário
    if (currentServerState.hasSecondaryLinkConfig) {
      if (prevServerState.secondaryLinkUp === true && !currentServerState.secondaryLinkUp) {
        alertMsgs.push(`${nomeReferencia}: Link secundário não acessível.`);
        playAlertSound();
      } else if (prevServerState.secondaryLinkUp === false && currentServerState.secondaryLinkUp) {
        if (currentServerStatus !== 'online' || prevGeneralStatus !== 'warning') {
          okMsgs.push(`${nomeReferencia}: Link secundário restabelecido.`);
          playOkSound();
        }
      }
    }

    // Verificar mudanças de status do link (funcionamento parcial/fora de operação)
    if (prevServerState.linkStatusText !== currentServerState.linkStatusText) {
      if (currentServerState.linkStatusText === 'Fora de Operação' && prevServerState.linkStatusText !== 'Fora de Operação') {
        alertMsgs.push(`${nomeReferencia}: Link fora de operação.`);
        playAlertSound();
      } else if (currentServerState.linkStatusText === 'Funcionamento Parcial' && prevServerState.linkStatusText === 'Fora de Operação') {
        okMsgs.push(`${nomeReferencia}: Link em funcionamento parcial.`);
        playOkSound();
      } else if (currentServerState.linkStatusText === 'Pleno Funcionamento' && prevServerState.linkStatusText !== 'Pleno Funcionamento') {
        okMsgs.push(`${nomeReferencia}: Link em pleno funcionamento.`);
        playOkSound();
      }
    }

    previousCriticalStates.value[id] = { ...currentServerState, generalStatus: currentServerStatus };
  });

  firstCheckDone = true;

  const uniqueAlertMsgs = [...new Set(alertMsgs)];
  const uniqueOkMsgs = [...new Set(okMsgs)];

  // Mostrar banners apenas para mensagens únicas
  uniqueAlertMsgs.forEach(msg => {
    showBanner('alert', msg);
  });
  uniqueOkMsgs.forEach(msg => {
    showBanner('ok', msg);
  });
};

watch(servers, () => {
  checkForAlerts();
}, { deep: true });

const initialized = ref(false);
const audioEnabled = ref(false);

function toggleAudio() {
  audioEnabled.value = !audioEnabled.value;
  localStorage.setItem('audioEnabled', audioEnabled.value ? 'true' : 'false');
  if (audioEnabled.value) {
    // Testar o áudio imediatamente
    const audioContext = window.AudioContext || window.webkitAudioContext;
    if (audioContext) {
      const context = new audioContext();
      if (context.state === 'suspended') {
        context.resume();
      }
    }
    
    // Tocar um som de teste
    const testAudio = new Audio('/sounds/ok.mp3');
    testAudio.volume = 0.3;
    testAudio.play().catch(() => { });
    
    // Mostrar feedback visual
    showBanner('ok', 'Sons do sistema ativados');
  } else {
    showBanner('alert', 'Sons do sistema desativados');
  }
}

const previousCriticalStates = ref({});

const getLinkStatusBadgeClass = (server) => {
  const link = server.link;
  if (!link || (typeof link !== 'object')) return 'bg-gray-100 dark:bg-gray-700 text-gray-600 dark:text-gray-300';

  const hasPrimary = link.primaryIP && link.primaryIP !== 'N/A' && link.primaryIP !== '';
  const hasSecondary = link.secondaryIP && link.secondaryIP !== 'N/A' && link.secondaryIP !== '';
  const syncPrimario = link.sync_primario === 'on';
  const syncSecundario = link.sync_secundario === 'on';

  // Ambos links
  if (hasPrimary && hasSecondary) {
    if (syncPrimario && syncSecundario) return 'bg-green-100 dark:bg-green-900/30 text-green-700 dark:text-green-400';
    if (!syncPrimario && !syncSecundario) return 'bg-red-100 dark:bg-red-900/30 text-red-700 dark:text-red-400';
    return 'bg-yellow-100 dark:bg-yellow-900/30 text-yellow-700 dark:text-yellow-400';
  }
  // Apenas primário
  if (hasPrimary) {
    if (syncPrimario) return 'bg-green-100 dark:bg-green-900/30 text-green-700 dark:text-green-400';
    return 'bg-red-100 dark:bg-red-900/30 text-red-700 dark:text-red-400';
  }
  // Apenas secundário
  if (hasSecondary) {
    if (syncSecundario) return 'bg-green-100 dark:bg-green-900/30 text-green-700 dark:text-green-400';
    return 'bg-red-100 dark:bg-red-900/30 text-red-700 dark:text-red-400';
  }
  return 'bg-gray-100 dark:bg-gray-700 text-gray-600 dark:text-gray-300';
}




</script>
